// 中文语言包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
  ...zhLocale,
  // 单据中心
  invoicesCenter: {
    dialogmodulestroeTitle: '1 调拨单',
    dialogmodulestroeFillinfo: '2 请填写信息',
    dialogmodulestroeReceiver: '3 收货方',
    dialogmodulestroeRemark: '4 备注',
    dialogmodulestroeSelectreceiver: '5 请选择收货方',
    dialogmodulestroeFillremark: '6 请填写备注信息',
    dialogmodulestroeAddgoodsdetail: '7 新增货品明细',
    dialogmodulestroeInputgoodsno: '8 请输入货号，多个用空格隔开',
    dialogmodulestroeSearch: '9 查 询',
    dialogmodulestroeSelectallpages: '10 跨页全选',
    dialogmodulestroeConfirmadd: '11 确认添加',
    dialogmodulestroeAddedgoodslist: '12 已添加货品列表',
    dialogmodulestroeScanbarcode: '13 请扫码或输入条码',
    dialogmodulestroeConfirm: '14 确定',
    dialogmodulestroeNegativescan: '15 负扫',
    dialogmodulestroePositivescan: '16 正扫',
    dialogmodulestroeEntergoodsno: '17 请输入货号',
    dialogmodulestroeClear: '18 清空',
    dialogmodulestroeViewscantrack: '19 查看扫码轨迹',
    dialogmodulestroeCurrentscannedgoods: '20 当前扫码货品',
    dialogmodulestroeGoodsno: '21 货号',
    dialogmodulestroeColor: '22 颜色',
    dialogmodulestroeSize: '23 尺码',
    dialogmodulestroeQuantityoutofrange: '24 数量',
    dialogmodulestroeInputcontent: '25 请输入内容',
    dialogmodulestroeSavedraft: '26 存入草稿',
    dialogmodulestroeSubmit: '27 确认提交',
    dialogmodulestroePleaseenterbarcode: '28 请输入条码',
    dialogmodulestroePleaseselectreceiver: '29 请选择收货方',
    dialogmodulestroeReceivercannotequalsender: '30 收货方不能等于发货方',
    dialogmodulestroeGoodsnoname: '31 货号名称',
    dialogmodulestroeUsablestock: '32 可用库存',
    dialogmodulestroeGoodsname: '33 货品名称',
    dialogmodulestroeRetailprice: '34 零售价',
    dialogmodulestroeAllotquantity: '35 调拨数',
    dialogmodulestroePleaseselectgoods: '36 请选择货品再添加',
    dialogmodulestroePleasefillallotquantity: '37 请填写调拨数',
    dialogmodulestroePleasefillremark: '38 请填写备注',
    dialogmodulestroeOperationsuccess: '39 操作成功',
    dialogmodulestroeConfirmdelete: '40 是否删除该条记录',
    dialogmodulestroeQuantityoutofrangeV1: '41 数量超出范围',
    dialogmodulestroeNegativestocknotallowed: '42 当前货品不允许负库存啦',
    dialogmodulestroeTips: '43 提示',
    differdetaildialogDiffinfo: '44 差异信息',
    differdetaildialogSendnum: '45 出货数',
    differdetaildialogReceivenum: '46 入库数',
    differdetaildialogDiscrepancynum: '47 入库差异',
    differdetaildialogSendduty: '48 发货方承担',
    differdetaildialogReceiveduty: '49 收货方承担',
    differdetaildialogTransportduty: '50 运输方承担',
    differdetaildialogStatus: '51 状态',
    differdetaildialogStatusunassigned: '52 未定责',
    differdetaildialogStatusassigned: '53 已定责',
    differdetaildialogPackcompletetime: '54 打包完成：',
    differdetaildialogInvoiceouttime: '55 出货时间：',
    differdetaildialogCheckcompletetime: '56 收货完成：',
    differdetaildialogDiffgoods: '57 差异货品',
    differdetaildialogGoodsno: '58 货号',
    differdetaildialogGoodsname: '59 货品名称',
    differdetaildialogColor: '60 颜色',
    differdetaildialogSize: '61 尺码',
    differdetaildialogDiff: '62 差异',
    differdetaildialogSenddutycol: '63 发货方承担',
    differdetaildialogReceivedutycol: '64 收货方承担',
    differdetaildialogTransportdutycol: '65 运输方承担',
    differdetaildialogDiffreceive: '66 差异收货',
    differdetaildialogCheckusername: '67 收货人：',
    differdetaildialogCheckcompletetimelabel: '68 收货时间：',
    differdetaildialogDiffresponsibility: '69 差异定责',
    differdetaildialogAffirmdutyusername: '70 定责人：',
    differdetaildialogAffirmdutytime: '71 定责时间：',
    differdetaildialogRemark: '72 定责说明：',
    differdetaildialogEvidence: '73 定责凭证：',
    differdetaildialogCloudwarehousetips: '74 发货方为云仓，会有如下情况：',
    differdetaildialogCloudwarehousecase: '75 ①、云仓有库存，但实物漏发了。',
    differdetaildialogCloudwarehousecasedetail: '76 联系京东线下补发，完成收货后再定责。由于系统逻辑是先收货再产生的差异记录，因此没有二次入库的途径，在定责时需要把云仓这部分的差异归为收货方承担才能让店铺库存对的上（收货方承担在正常场景里属于漏收，所以系统会自动补上库存）',
    differdetaildialogCloudwarehousecaseV1: '77 ②、云仓没库存但京东误操作让单子多出货了。或者某个款临时通知不下发但云仓已经操作出货了，线下把实物取出不发。',
    differdetaildialogCloudwarehousecasedetailV1: '78 定责时将差异归为发货方承担系统逻辑会自动将差异的数量返还给发货方增加库存。但由于无法直接对京东的数据进行改动，需要在京东后台做单，让京东系统和自己系统的库存两边对的上。',
    differdetaildialogTransportdutytips: '79 运输方承担的差异数量，除了需要向物流索要赔付，还需要额外做库存调整单来减掉库存。',
    differdetaildialogTitleprefix: '80 收货差异详情—',
    differdetaildialogTitle: '81 收货差异详情',
    endpackCompletecheck: '82 完成验收',
    endpackCompletepick: '83 完成拣货',
    endpackDiffconfirmprefix: '84 当前数据存在差异是否继续“提交',
    endpackChecktext: '85 验收',
    endpackPicktext: '86 拣货',
    endpackTotalquantity: '87 总数量：',
    endpackCompletedprefix: '88 已',
    endpackChecklabel: '89 验收：',
    endpackPicklabel: '90 拣货：',
    endpackOverprefix: '91 超',
    endpackCheckoverlabel: '92 验收：',
    endpackPickoverlabel: '93 拣货：',
    endpackPendingprefix: '94 未',
    endpackCheckpendinglabel: '95 验收：',
    endpackPickpendinglabel: '96 拣货：',
    endpackCancel: '97 取消',
    endpackConfirm: '98 确定',
    entrycourierinfoDialogtitle: '99 录入快递信息',
    entrycourierinfoDocumentnumber: '100 单据号',
    entrycourierinfoSender: '101 发出方',
    entrycourierinfoReceiver: '102 收货方',
    entrycourierinfoModify: '103 修改',
    entrycourierinfoSelectentrymethod: '104 选择录入方式：',
    entrycourierinfoAutojdorder: '105 自动京东下单',
    entrycourierinfoManualorder: '106 手动下单',
    entrycourierinfoNoexpressshipment: '107 免快递出货',
    entrycourierinfoScanexpressno: '108 请扫描或输入快递单号',
    entrycourierinfoConfirm: '109 确定',
    entrycourierinfoLogisticscompany: '110 快递公司',
    entrycourierinfoPleaseselect: '111 请选择',
    entrycourierinfoPaymenttype: '112 现付/月结',
    entrycourierinfoMonthlyaccount: '113 月结账号',
    entrycourierinfoCashpayment: '114 现付',
    entrycourierinfoMonthlypayment: '115 月结',
    entrycourierinfoEstimatedweight: '116 预估重量：',
    entrycourierinfoKilogram: ' 公斤',
    entrycourierinfoWeightcalculation: ' （根据货品资料克重计算）',
    entrycourierinfoHeavyweightexpress: '119 当前重量>30公斤，将下单京东快运',
    entrycourierinfoLightweightexpress: '120 当前重量<30公斤，将下京东快递',
    entrycourierinfoSystemruleorder: '121 按系统规则下单',
    entrycourierinfoForceheavyexpress: '122 强制下重货快运',
    entrycourierinfoCancel: '123 取 消',
    entrycourierinfoSubmit: '124 确 定',
    entrycourierinfoModifyreceivername: '125 请修改收件人姓名',
    entrycourierinfoInputreceivername: '126 请输入收件人姓名',
    entrycourierinfoModifyreceiverphone: '127 请修改收件人手机号',
    entrycourierinfoInputreceiverphone: '128 请输入收件人手机号',
    entrycourierinfoRequiredlogisticscompany: '129 请选择快递公司',
    entrycourierinfoRequiredexpressno: '130 请填写快递单号',
    entrycourierinfoRequiredpaymenttype: '131 请选择是现付/月结',
    entrycourierinfoRequiredmonthlyaccount: '132 请填写月结账号',
    entrycourierinfoOperationsuccess: '133 操作成功',
    packageepcphDialogtitle: '134 提示',
    packageepcphPackagedetails: '135 包裹明细',
    packageepcphSearchlabel: '136 货号/条码/简码',
    packageepcphSearchplaceholder: '137 输入后按回车搜索',
    packageepcphGoodstab: '138 货品',
    packageepcphTotal: '139 总计',
    packageepcphTotalamount: '140 总款数：',
    packageepcphUnitpiece: ' 个',
    packageepcphTotalcount: '142 总件数：',
    packageepcphUnititem: ' 件',
    packageepcphColumngoodsno: '144 货号',
    packageepcphColumngoodsname: '145 货品名称',
    packageepcphColumncolor: '146 颜色',
    packageepcphColumnsize: '147 尺码',
    packageepcphColumnquantity: '148 数量',
    packageepcphColumntotal: '149 总数',
    printdeliveryorderPrinttitle: '150 打印单据',
    printdeliveryorderDeliveryinfotitle: '151 随货单信息',
    printdeliveryorderPackageinfotitle: '152 包裹信息',
    printdeliveryorderPrintbutton: '153 打印',
    printdeliveryorderDocumentdatelabel: '154 单据日期：',
    printdeliveryorderDocumentnolabel: '155 单号：',
    printdeliveryorderSenderlabel: '156 发货方：',
    printdeliveryorderReceiverlabel: '157 收货方：',
    printdeliveryorderPackagenolabel: '158 包裹号：',
    printdeliveryorderStorenolabel: '159 店铺编号：',
    printdeliveryorderRemarklabel: '160 备注：',
    printdeliveryorderRemarkcontent: '161 这里是备注信息',
    printdeliveryorderEstimatedweightlabel: '162 预估重量：',
    printdeliveryorderActualweightlabel: '163 实际称重：',
    printdeliveryorderSummarycolumn: '164 汇总',
    printdeliveryorderGoodsnamecolumn: '165 货品名称',
    printdeliveryorderGoodsnocolumn: '166 货号',
    printdeliveryorderColorcolumn: '167 颜色',
    printdeliveryorderGoodsdistributiontitle: '168 商品铺货单',
    printdeliveryorderStoreouttitle: '169 店铺调出单',
    printdeliveryorderStorereturntitle: '170 店铺退货单',
    printdeliveryorderStorereturnsupplytitle: '171 店铺退供单',
    puhuotablePhnumber: '172 铺货数量',
    puhuotableTcnumber: '173 退仓数量',
    puhuotableDbnumber: '174 调拨数量',
    puhuotableChnumber: '175 出货数量',
    puhuotableChdnumber: '176 出货差异',
    puhuotableRknumber: '177 入库数量',
    puhuotableRkdnumber: '178 入库差异',
    puhuotableSummary: '179 汇总',
    puhuotableOperation: '180 操作',
    puhuotableUsablestock: '181 可用库存',
    puhuotableTgnumber: '182 退供数',
    puhuotableThnumber: '183 退货数',
    puhuotableTotal: '184 总',
    puhuotableReceived: '185 已',
    puhuotableUnreceived: '186 未',
    puhuotableDelete: '187 删除',
    puhuotableTotalrow: '188 合计',
    puhuotableTotalamount: '189 总款数',
    puhuotableRetailtotal: '190 零售总价',
    puhuotableTotalpieces: '191 总件数',
    puhuotableShipmentdifftotal: '192 出货差异总数',
    puhuotableStoragedifftotal: '193 入库差异总数',
    puhuotableConfirmdelete: '194 是否删除该条记录',
    puhuotableTips: '195 提示',
    puhuotableOperationsuccess: '196 操作成功',
    puhuotableInputpositiveinteger: '197 请输入大于或者等于0的整数',
    puhuotableTransferlimit: '198 调拨数不能大于可以库存',
    puhuotableInputvalidvalue: '199 请输入有效值',
    puhuotableConfirmclear: '200 是否将记录清空',
    puhuotableCheckablequantity: '201 可验收数量为',
    puhuotableTransferstock: '202 调拨数',
    puhuotableTipsV1: '203 提示',
    puhuotablePuhuonum: '204 铺货数量',
    puhuotableTuicangnum: '205 退仓数量',
    puhuotableDiaobonum: '206 调拨数量',
    puhuotableChuhuonum: '207 出货数量',
    puhuotableChuhuodiff: '208 出货差异',
    puhuotableRukunum: '209 入库数量',
    puhuotableRukudiff: '210 入库差异',
    puhuotableTihuonum: '211 提货数量',
    puhuotableTuigongnum: '212 退供数量',
    puhuotableYitinum: '213 已提数量',
    puhuotableWeitinum: '214 未提数量',
    puhuotableCaigounum: '215 采购数量',
    puhuotableAvailablestock: '216 可用库存',
    puhuotableOccupiedstock: '217 占用库存',
    puhuotableTransitstock: '218 在途库存',
    puhuotableFinishedfirstorder: '219 成品首单',
    puhuotableFinishedreplenishorder: '220 成品补单',
    puhuotableProcessfirstorder: '221 加工首单',
    puhuotableProcessreplenishorder: '222 加工补单',
    puhuotableMaterialfirstorder: '223 面辅料首单',
    puhuotablePuhuocount: '224 铺货数',
    puhuotableTuicangcount: '225 退仓数',
    puhuotableDiaobocount: '226 调拨数',
    puhuotableReturnsupply: '227 退供',
    puhuotableOrderquantitygarment: '228 下单数量(成衣)',
    puhuotableCompletequantity: '229 完成数量',
    puhuotableDifference: '230 差异',
    puhuotableOriginaltransitstock: '231 原在途库存',
    puhuotableAdjustto: '232 调整为',
    puhuotableTotalcount: '233 总数',
    puhuotableAlreadyreceived: '234 已收',
    puhuotableNotreceived: '235 未收',
    puhuotablePurchasecount: '236 采购数',
    puhuotableStoragecount: '237 入库数',
    puhuotableAlreadytaken: '238 已提数',
    puhuotableNottaken: '239 未提数',
    puhuotableCurrenttakedelivery: '240 本次提货',
    puhuotableReturncount: '241 退货数',
    puhuotableSelectdate: '242 选择日期',
    puhuotableDeleteV1: '243 删除',
    puhuotableBatchmodify: '244 批量修改',
    puhuotableTotalV1: '245 合计',
    puhuotableTotalstyles: '246 总款数',
    puhuotableTotalpiecesV1: '247 总件数',
    puhuotableTotalprice: '248 总价',
    puhuotableTotalretailprice: '249 零售总价',
    puhuotableTotalshipmentdiff: '250 出货差异总数',
    puhuotableTotalstoragediff: '251 入库差异总数',
    puhuotableTotaladjustpieces: '252 调整总件数',
    puhuotableReturnsupplyamount: '253 退供金额',
    puhuotableBatchadjustretailprice: '254 批量调整零售价',
    puhuotablePleaseinput: '255 请输入',
    puhuotableCancel: '256 取 消',
    puhuotableConfirm: '257 确 定',
    puhuotableAddpurchasequantity: '258 请添加需要的采购商品数量',
    puhuotableSelectdeliverydaterange: '259 请选择首批交货日期范围',
    puhuotableFirstdeliverydateerror: '260 首批交货日期不能大于最终交货日期',
    puhuotableConfirmdeleteV1: '261 是否删除该条记录',
    puhuotableTip: '262 提示',
    puhuotableOperationsuccessV1: '263 操作成功',
    puhuotableInputpositiveintegerV1: '264 请输入大于等于0的整数',
    puhuotableReturncannotexceedstock: '265 退仓数不能大于可用库存',
    puhuotableDistributioncannotexceedstock: '266 铺货数不能大于可用库存',
    puhuotableTakecannotexceeduntaken: '267 提货数不能大于未提数',
    puhuotableReturncannotexceedstorage: '268 退供数不能大于入库数',
    puhuotableConfirmclearall: '269 此操作将会清空添加记录',
    puhuotableInputvalidvalueV1: '270 请输入有效值',
    puhuotableCheckquantitylimit: '271 可验收数量为',
    puhuotableInputvalidvalueNum: '272 请输入调整的数字',
    puhuotableSizegroup: '273 尺码组',
    puhuotablePieces: ' 件',
    returndialogTitle: '275 新增店铺退供单',
    returndialogConfirmsubmit: '276 确认提交',
    returndialogFillinfo: '277 请填写信息',
    returndialogReceiver: '278 收货方',
    returndialogSelectsupplier: '279 请选择供应商',
    returndialogRemark: '280 备注',
    returndialogFillremark: '281 请填写备注信息',
    returndialogAddgoodsdetail: '282 新增货品明细',
    returndialogSelectgoodsno: '283 请选择货号',
    returndialogQuery: '284 查 询',
    returndialogSelectallpages: '285 跨页全选',
    returndialogConfirmadd: '286 确认添加',
    returndialogAddedgoodslist: '287 已添加货品列表',
    returndialogSearchgoodsno: '288 搜索货号',
    returndialogInputgoodsno: '289 请输入货号',
    returndialogSearch: '290 查询',
    returndialogClearall: '291 一键清空',
    returndialogInputcontent: '292 请输入内容',
    returndialogGoodsno: '293 货号',
    returndialogGoodsname: '294 货号名称',
    returndialogAvailablestock: '295 可用库存',
    returndialogProductname: '296 货品名称',
    returndialogRetailprice: '297 零售价',
    returndialogColor: '298 颜色',
    returndialogReturnsupplycount: '299 退供数',
    returndialogPleaseselect: '300 请选择',
    returndialogSelectgoodsfirst: '301 请选择货品再添加',
    returndialogMaxaddlimit: '302 一次最多添加',
    returndialogRecords: '303 {count}条记录',
    returndialogSelectreceiver: '304 请选择收货方',
    returndialogFillreturncount: '305 请填写退供数',
    returndialogOperationsuccess: '306 操作成功',
    returndialogConfirmdelete: '307 是否删除该条记录',
    returndialogTip: '308 提示',
    scantrajectoryTitle: '309 扫码历史轨迹',
    scantrajectorySerialnumber: '310 序号',
    scantrajectoryScannedgoods: '311 扫码货品',
    scantrajectoryGoodsno: '312 货号',
    scantrajectoryColor: '313 颜色',
    scantrajectorySize: '314 尺码',
    scantrajectoryScancount: '315 扫码数量',
    detailTitle: '316 单据详情',
    detailStartaccept: '317 开始验收',
    detailStartpick: '318 开始拣货',
    detailInvoiceinfo: '319 单据信息',
    detailCreator: '320 创建人',
    detailSender: '321 发货方',
    detailReceiver: '322 收货方',
    detailTransfernum: '323 调拨数量',
    detailOutnum: '324 出货数量',
    detailInnum: '325 入库数量',
    detailOutdiffnum: '326 出货差异数',
    detailIndiffnum: '327 入库差异数',
    detailCreatetime: '328 创建时间',
    detailUpdatetime: '329 更新时间',
    detailLastmodifier: '330 最后修改人',
    detailTotaltime: '331 总耗时',
    detailGoodsmanager: '332 商品负责人',
    detailRemark: '333 备注',
    detailDiffreason: '334 差异出货原因',
    detailProductlist: '335 商品列表',
    detailDeliveryinfo: '336 发货信息',
    detailOrderno: '337 单号',
    detailPackageno: '338 包裹号',
    detailProductnum: '339 货品数量',
    detailLogisticsname: '340 物流公司',
    detailExpressno: '341 快递单号',
    detailStatus: '342 状态',
    detailPendingupdate: '343 待更新',
    detailPackfinishtime: '344 打包完成时间',
    detailShiptime: '345 发货时间',
    detailSigntime: '346 签收时间',
    detailAction: '347 操作',
    detailViewpackage: '348 查看包裹',
    detailLogisticstrack: '349 物流轨迹',
    detailModifyinfo: '350 修改信息',
    detailPrint: '351 打印',
    detailDiffinfo: '352 收货差异信息',
    detailConsignee: '353 收货人',
    detailReceivefinishtime: '354 收货完成时间',
    detailOutlabelnum: '355 出货标签数量',
    detailDifference: '356 差异',
    detailSenderduty: '357 发货方责任',
    detailReceiverduty: '358 收货方责任',
    detailTransportduty: '359 运输方责任',
    detailUndetermined: '360 未定责',
    detailDetermined: '361 已定责',
    detailViewdetail: '362 查看详情',
    detailCancelapply: '363 作废申请记录',
    detailApplicant: '364 申请人',
    detailApplytime: '365 申请时间',
    detailApplyreason: '366 申请理由',
    detailPendingapproval: '367 待审批',
    detailApproved: '368 已通过',
    detailRejected: '369 已拒绝',
    detailApprover: '370 审批人',
    detailApprovetime: '371 审批时间',
    detailSelectpackage: '372 请选择包裹号',
    detailSelect: '373 选择',
    detailPackageexpressno: '374 包裹快递号',
    detailAcceptstatus: '375 验收状态',
    detailUnaccepted: '376 未验收',
    detailAccepting: '377 验收中',
    detailAccepted: '378 已验收',
    detailProductcount: '379 货品件数',
    detailConfirm: '380 确 定',
    detailChoosepackage: '381 请选择包裹号',
    detailPackageaccepted: '382 该包裹已验收，无法选择！',
    detailUsepda: '383 请用PDA拣货',
    detailRfidnotice: '384 本单已通过RFID芯片进行出货，并且店铺已经开启了使用RFID芯片收货。请使用盘点机对本单进行收货！',
    detailGotit: '385 知道了',
    detailCancelexpress: '386 是否取消快递单',
    detailCancelsuccess: '387 取消成功',
    detailTip: '388 提示',
    tableconfigGoodsname: '389 货品名称',
    tableconfigGoodsnowithimage: '390 货号 (点击查看图片)',
    tableconfigRetailprice: '391 零售价',
    tableconfigTotal: '392 汇总',
    tableconfigColor: '393 颜色',
    tableconfigRemark: '394 备注',
    tableconfigGoodsno: '395 货号',
    tableconfigPuhuoquantity: '396 铺货数量',
    tableconfigShipmentquantity: '397 出货数量',
    tableconfigShipmentdifference: '398 出货差异',
    tableconfigStoragequantity: '399 入库数量',
    tableconfigStoragedifference: '400 入库差异',
    tableconfigReturnwarehousequantity: '401 退仓数量',
    tableconfigReturnsupplierquantity: '402 退供数量',
    tableconfigTransferquantity: '403 调拨数量',
    tableconfigTotalitems: '404 总款数',
    tableconfigTotaltransferitems: '405 调拨总件数',
    tableconfigTotalshipmentdifference: '406 出货差异总数',
    tableconfigTotalstoragedifference: '407 入库差异总数',
    tableconfigView: '408 查看',
    tableconfigUsableinventory: '409 可用库存',
    tableconfigReturnquantity: '410 退货数',
    tableconfigDelete: '411 删除',
    tableconfigShortcode: '412 简码',
    tableconfigQuantity: '413 数量',
    tableconfigTotalgoods: '414 货品总数',
    trackdialogTitle: '415 物流轨迹',
    trackdialogSender: '416 发货方',
    trackdialogContact: '417 联系方式',
    trackdialogSenderaddr: '418 发货地址',
    trackdialogLogisticsname: '419 快递公司',
    trackdialogExpressno: '420 快递单号',
    trackdialogDeliverytime: '421 预计送达时间',
    trackdialogQuerybtn: '422 查询',
    trackdialogTableindex: '423 序号',
    trackdialogTabletime: '424 时间',
    trackdialogTabletrack: '425 物流轨迹',
    checkacceptpackdrawerTitle: '426 验收',
    checkacceptpackdrawerSender: '427 发货方：',
    checkacceptpackdrawerInvoicessn: '428 单据号',
    checkacceptpackdrawerPackageno: '429 包裹号',
    checkacceptpackdrawerOnekeyaccept: '430 一键验收',
    checkacceptpackdrawerClearall: '431 清空验收数',
    checkacceptpackdrawerCompleteaccept: '432 完成验收并提交',
    checkacceptpackdrawerScanplaceholder: '433 请扫码或输入条码',
    checkacceptpackdrawerConfirm: '434 确定',
    checkacceptpackdrawerNegativescan: '435 负扫',
    checkacceptpackdrawerPositivescan: '436 正扫',
    checkacceptpackdrawerShowunreceived: '437 只显示未收',
    checkacceptpackdrawerEntergoodsno: '438 请输入货号',
    checkacceptpackdrawerQuery: '439 查询',
    checkacceptpackdrawerScantrajectory: '440 扫码轨迹',
    checkacceptpackdrawerCurrentgoods: '441 当前扫码货品',
    checkacceptpackdrawerGoodsno: '442 货号',
    checkacceptpackdrawerColor: '443 颜色',
    checkacceptpackdrawerSize: '444 尺码',
    checkacceptpackdrawerQuantity: '445 数量',
    checkacceptpackdrawerMinaccept: '446 请至少验收一件',
    checkacceptpackdrawerNodifference: '447 不允许差异提交，请联系商品人员',
    checkacceptpackdrawerSuccess: '448 操作成功',
    checkacceptpackdrawerNoacceptyet: '449 还没有开始验收',
    checkacceptpackdrawerMaxaccept: '450 可验收数量为',
    checkacceptpackdrawerGoodsnoNum: '451 货品名称',
    checkacceptpackdrawerProductName: '452 货号',
    checkacceptpacktableGoodsname: '453 货品名称',
    checkacceptpacktableGoodsno: '454 货号 (点击查看图片)',
    checkacceptpacktableColor: '455 颜色',
    checkacceptpacktableTotal: '456 汇总',
    checkacceptpacktableTotalnum: '457 总数',
    checkacceptpacktableReceived: '458 已收',
    checkacceptpacktableUnreceived: '459 未收',
    checkacceptpacktableTotalitems: '460 总件数',
    checkacceptpacktableFooterreceived: '461 已收',
    checkacceptpacktableFooterunreceived: '462 未收',
    distributioncheckTitle: '463 验收',
    distributioncheckSenderlabel: '464 发货方：',
    distributioncheckInvoicenolabel: '465 单据号',
    distributioncheckPackagenolabel: '466 包裹号',
    distributioncheckOnekeyacceptancebtn: '467 一键验收',
    distributioncheckClearacceptancebtn: '468 清空验收数',
    distributioncheckSubmitbtn: '469 完成验收并提交',
    distributioncheckBarcodeplaceholder: '470 请扫码或输入条码',
    distributioncheckNegativescan: '471 负扫',
    distributioncheckPositivescan: '472 正扫',
    distributioncheckOnlyshowunreceived: '473 只显示未收',
    distributioncheckGoodsnoplaceholder: '474 请输入货号',
    distributioncheckSearchbtn: '475 查询',
    distributioncheckScantrajectorybtn: '476 扫码轨迹',
    distributioncheckCurrentgoodslabel: '477 当前扫码货品',
    distributioncheckGoodsnolabel: '478 货号',
    distributioncheckColorlabel: '479 颜色',
    distributioncheckSizelabel: '480 尺码',
    distributioncheckQuantitylabel: '481 数量',
    distributioncheckAtleastoneaccept: '482 请至少验收一件',
    distributioncheckNodiffsubmit: '483 不允许差异提交，请联系商品人员',
    distributioncheckNoacceptyet: '484 还没有开始验收',
    distributioncheckOperationsuccess: '485 操作成功',
    distributioncheckAcceptablequantity: '486 可验收数量为',
    distributioncheckProductsubmit: '487 确定',
    distributioncheckProductNamelabel: '488 货品名称',
    distributiondetailTitle: '489 单据详情',
    distributiondetailStartacceptbtn: '490 开始验收',
    distributiondetailInvoiceinfosection: '491 单据信息',
    distributiondetailCreatorlabel: '492 创建人',
    distributiondetailSenderlabel: '493 发货方',
    distributiondetailReceiverlabel: '494 收货方',
    distributiondetailPlancountlabel: '495 计划数量',
    distributiondetailShipmentcountlabel: '496 出货数量',
    distributiondetailStoragecountlabel: '497 入库数量',
    distributiondetailShipmentdiffcountlabel: '498 出货差异数',
    distributiondetailStoragediffcountlabel: '499 入库差异数',
    distributiondetailCreatetimelabel: '500 创建时间',
    distributiondetailUpdatetimelabel: '501 更新时间',
    distributiondetailLastmodifierlabel: '502 最后修改人',
    distributiondetailTotaltimelabel: '503 总耗时',
    distributiondetailProductmanagerlabel: '504 商品负责人',
    distributiondetailRemarklabel: '505 备注',
    distributiondetailProductlistsection: '506 商品列表',
    distributiondetailShipmentinfosection: '507 发货信息',
    distributiondetailInvoicenolabel: '508 单号',
    distributiondetailSendernamelabel: '509 发货方',
    distributiondetailReceivernamelabel: '510 收货方',
    distributiondetailPackagenolabel: '511 包裹号',
    distributiondetailProductcountlabel: '512 货品数量',
    distributiondetailWeightlabel: '513 重量',
    distributiondetailLogisticscompanylabel: '514 物流公司',
    distributiondetailTrackingnolabel: '515 快递单号',
    distributiondetailStatuslabel: '516 状态',
    distributiondetailShipmenttimelabel: '517 发货时间',
    distributiondetailSigntimelabel: '518 签收时间',
    distributiondetailActionlabel: '519 操作',
    distributiondetailViewpackagebtn: '520 查看包裹',
    distributiondetailTrackingbtn: '521 物流轨迹',
    distributiondetailDiffinfosection: '522 收货差异信息',
    distributiondetailReceiverlabelV1: '523 收货人',
    distributiondetailReceivecompletetimelabel: '524 收货完成时间',
    distributiondetailShipmentlabelcountlabel: '525 出货标签数量',
    distributiondetailDifferencelabel: '526 差异',
    distributiondetailSenderresponsibilitylabel: '527 发货方责任',
    distributiondetailReceiverresponsibilitylabel: '528 收货方责任',
    distributiondetailTransportresponsibilitylabel: '529 运输方责任',
    distributiondetailUndeterminedresponsibility: '530 未定责',
    distributiondetailDeterminedresponsibility: '531 已定责',
    distributiondetailViewdetailbtn: '532 查看详情',
    distributiondetailCancelrecordsection: '533 作废申请记录',
    distributiondetailApplicantlabel: '534 申请人',
    distributiondetailApplytimelabel: '535 申请时间',
    distributiondetailApplyreasonlabel: '536 申请理由',
    distributiondetailPendingapproval: '537 待审批',
    distributiondetailApproved: '538 已通过',
    distributiondetailRejected: '539 已拒绝',
    distributiondetailApproverlabel: '540 审批人',
    distributiondetailApprovetimelabel: '541 审批时间',
    distributiondetailSelectpackagetitle: '542 请选择包裹号',
    distributiondetailSelectlabel: '543 选择',
    distributiondetailConfirmbtn: '544 确 定',
    distributiondetailNotaccepted: '545 未验收',
    distributiondetailAcceptin: '546 验收中',
    distributiondetailAccepted: '547 已验收',
    distributiondetailNotcollected: '548 未揽收',
    distributiondetailPendingshipment: '549 待发货',
    distributiondetailIntransit: '550 运输中',
    distributiondetailIndelivery: '551 配送中',
    distributiondetailDelivered: '552 已妥投',
    distributiondetailCancelexpressconfirm: '553 是否取消快递单',
    distributiondetailCancelsuccess: '554 取消成功',
    distributiondetailRfidwarningmsg: '555 本单已通过RFID芯片进行出货，并且店铺已经开启了使用RFID芯片收货。请使用盘点机对本单进行收货！',
    distributiondetailWarningtitle: '556 提示',
    distributiondetailConfirmknow: '557 知道了',
    distributiondetailNoacceptyet: '558 该包裹已验收，无法选择！',
    endpackAccepttitle: '559 完成验收',
    endpackPicktitle: '560 完成拣货',
    endpackAcceptconfirmmsg: '561 当前数据存在差异是否继续"提交验收"',
    endpackPickconfirmmsg: '562 当前数据存在差异是否继续"提交拣货"',
    endpackTotalcountlabel: '563 总数量：',
    endpackAcceptedlabel: '564 已验收：',
    endpackPickedlabel: '565 已拣货：',
    endpackOveracceptlabel: '566 超验收：',
    endpackOverpicklabel: '567 超拣货：',
    endpackUnacceptlabel: '568 未验收：',
    endpackUnpicklabel: '569 未拣货：',
    endpackCancelbtn: '570 取 消',
    endpackConfirmbtn: '571 确 定',
    packageepcphDialogtitleV1: '572 提示',
    packageepcphPackagedetail: '573 包裹明细',
    packageepcphGoodsinputlabel: '574 货号/条码/简码',
    packageepcphInputplaceholder: '575 输入后按回车搜索',
    packageepcphGoodstabV1: '576 货品',
    packageepcphTotallabel: '577 总计',
    packageepcphTotalamountlabel: '578 总款数：',
    packageepcphUnitpieceV1: ' 个',
    packageepcphTotalquantitylabel: '580 总件数：',
    packageepcphUnititemV1: ' 件',
    packageepcphGridgoodsno: '582 货号',
    packageepcphGridgoodsname: '583 货品名称',
    packageepcphGridcolor: '584 颜色',
    packageepcphGridsize: '585 尺码',
    packageepcphGridquantity: '586 数量',
    packageepcphGridtotal: '587 总数',
    submitdialogDialogtitle: '588 收货数量有差异，请确认差异情况',
    submitdialogOrdernolabel: '589 单号：',
    submitdialogPackagenolabel: '590 包裹号：',
    submitdialogTotallabel: '591 总数：',
    submitdialogReceivedlabel: '592 已收：',
    submitdialogUnreceivedlabel: '593 未收：',
    submitdialogInstruction: '594 返回界面筛选“仅看未收完”对未收完的货品清点实物数量，如果发现实物还有漏收的继续操作补收。',
    submitdialogInstructionV1: '595 <span style="color:red;">如果确实少货了</span>，请在监控下清点所有货品数量并对外包装和快递面单拍照留底，然后点击下方提交差异按钮。系统会对未收的<span style="color:red;">{count}</span>件会产生差异记录，店铺需要联系IT专员反馈差异情况等待后台核实。可前往单据详情查看差异记录，',
    submitdialogSubmitbtn: '596 确定少货，提交差异收货',
    tableconfigGoodsnameV1: '597 货品名称',
    tableconfigGoodsnowithimageV1: '598 货号 (点击查看图片)',
    tableconfigRetailpriceV1: '599 零售价',
    tableconfigColorV1: '600 颜色',
    tableconfigTotalV1: '601 汇总',
    tableconfigDistributionquantity: '602 铺货数量',
    tableconfigShipmentquantityV1: '603 出货数量',
    tableconfigShipmentdifferenceV1: '604 出货差异',
    tableconfigStoragequantityV1: '605 入库数量',
    tableconfigStoragedifferenceV1: '606 入库差异',
    tableconfigShortcodeV1: '607 简码',
    tableconfigGoodsnoV1: '608 货号',
    tableconfigQuantityV1: '609 数量',
    tableconfigTotalstyles: '610 总款数',
    tableconfigUnitpiece: ' 个',
    tableconfigTotalitemsV1: '612 总件数',
    tableconfigUnititem: ' 件',
    configbutionOrderno: '614 配货单号',
    configbutionState: '615 状态',
    configbutionStatedraft: '616 草稿单(蓝色)：临时保存单据草稿，不会占用库存',
    configbutionStatepresubmit: '617 预提交（紫色）：先提交单据，但不会下发到仓库，会占用仓库库存',
    configbutionStatereleased: '618 已下发（绿色）：已提交单据，且下发到仓库，待仓库拣货出库',
    configbutionStatepicking: '619 拣货中（橙色）：仓库收到指令，正在拣货下架',
    configbutionStatepickcompleted: '620 拣货完成（绿色）：仓库拣货完成并提交，放入待打包区',
    configbutionStatepacking: '621 打包中（橙色）：打包人进行封包装袋',
    configbutionStatepackcompleted: '622 打包完成（绿色）：装袋完成，等待录入快递信息后出货',
    configbutionStateshipped: '623 已出货（蓝色）：仓库已按照配货单拣货出库，会扣减仓库库存，物流状态在途',
    configbutionStateshippeddetail: '624 将增加店铺在途库存',
    configbutionStatesigned: '625 已签收（绿色）：走合作物流发货时，物流信息已到店签收，等待店铺拆包验收',
    configbutionStatechecking: '626 验收中（橙色）：店铺正在拆包验收',
    configbutionStatestockin: '627 已入库（绿色）：验收完成后，操作确认入库，店铺的在途库存变为实际增加库存',
    configbutionStatecancelled: '628 已作废（红色）：草稿单、预提交、已下发，这三个状态可进行作废操作',
    configbutionStatecancelapply: '629 申请作废（红色）：已出货单据进行申请作废',
    configbutionHasdiscrepancy: '630 收货差异待处理',
    configbutionYes: '631 是',
    configbutionNo: '632 否',
    configbutionUpdatetime: '633 更新时间',
    configbutionSender: '634 发货方',
    configbutionBoxorderno: '635 箱标订单号',
    configbutionReceiver: '636 收货方',
    configbutionIncomingquantity: '637 来货数量',
    configbutionStockinquantity: '638 入库数量',
    configbutionOrderpackagecount: '639 订单包裹数',
    configbutionShippedpackagecount: '640 出货包裹数',
    configbutionReceivedpackagecount: '641 已收包裹数',
    configbutionUnreceivedpackagecount: '642 未收包裹数',
    configbutionStockindifference: '643 入库差异数',
    configbutionGoodsmanager: '644 商品负责人',
    configbutionRemark: '645 备注',
    configbutionCreator: '646 创建人',
    configbutionCreatetime: '647 创建时间',
    configbutionModifier: '648 修改人',
    configbutionSelectstateplaceholder: '649 请选择状态',
    configbutionStateshippedtext: '650 已出货',
    configbutionStatesignedtext: '651 已签收',
    configbutionStatecheckingtext: '652 验收中',
    configbutionStatestockintext: '653 已入库',
    configbutionStatecancelapplytext: '654 作废申请',
    configbutionSelectplaceholder: '655 请选择',
    configbutionFilterdiscrepancy: '656 是否仅看收货差异待处理',
    configbutionHasdiscrepancyrecord: '657 是否有差异记录',
    configbutionInputordernoplaceholder: '658 请输入单号',
    configbutionOrdernolabel: '659 单号',
    configbutionInputexpressnoplaceholder: '660 请输入快递单号',
    configbutionExpressnolabel: '661 快递单号',
    configbutionInputboxordernoplaceholder: '662 请输入箱标订单号',
    configbutionSelectsenderplaceholder: '663 请选择发货方',
    configbutionInputgoodsnoplaceholder: '664 请输入货号，多个用空格隔开',
    configbutionGoodsnolabel: '665 货号',
    configbutionInputcreatorplaceholder: '666 请填写创建人',
    configbutionSelectgoodsmanagerplaceholder: '667 请选择商品负责人',
    configbutionSelectcreatetimeplaceholder: '668 请选择创建时间',
    configbutionSelectupdatetimeplaceholder: '669 请选择更新时间',
    configbutionSearchbutton: '670 查询',
    configbutionResetbutton: '671 重置',
    configtransSn: '672 单号',
    configtransStatedesc: '673 状态',
    statedescShipmentout: '674 已出货（蓝色）：店铺已按照退仓单拣货出库，会扣减店铺库存，物流状态在途，将增加店铺库在途库存',
    statedescSigned: '675 已签收（紫色）：走合作物流发货时，物流信息已到店签收，等待店铺拆包验收',
    statedescChecking: '676 验收中（橙色）：店铺拆包验收中',
    statedescInstock: '677 已入库（绿色）：验收完成后，操作确认入库，店铺的在途库存变为实际增加库存',
    statedescCancelapply: '678 申请作废（红色）：已出货单据进行申请作废',
    configtransIfdiscrepancy: '679 收货差异待处理',
    configtransYes: '680 是',
    configtransNo: '681 否',
    configtransOutmarketname: '682 发货方',
    configtransInmarketname: '683 收货方',
    configtransTotalnum: '684 计划数量',
    configtransOutnum: '685 出货数量',
    configtransOutpackagenum: '686 出货包裹数',
    configtransOutnumdifference: '687 出货差异数',
    configtransInnum: '688 入库数量',
    configtransLogisticpackagechecknum: '689 入库包裹数',
    configtransInnumdifference: '690 入库差异数',
    configtransRemark: '691 备注',
    configtransCreateusername: '692 创建人',
    configtransCreatetime: '693 创建时间',
    configtransUpdatetime: '694 更新时间',
    configtransUpdateusername: '695 修改人',
    placeholderInvoicesno: '696 请输入单号',
    labelInvoicesno: '697 单号',
    placeholderSelect: '698 请选择',
    labelIfdiscrepancy: '699 是否仅看收货差异待处理',
    labelHasdiscrepancy: '700 是否有差异记录',
    placeholderExpressno: '701 请输入快递单号',
    labelExpressno: '702 快递单号',
    placeholderState: '703 请选择状态',
    labelState: '704 状态',
    stateShipmentout: '705 已出货',
    stateSigned: '706 已签收',
    stateChecking: '707 验收中',
    stateInstock: '708 已入库',
    stateCancelapply: '709 作废申请',
    stateCanceled: '710 已作废',
    placeholderOutmarket: '711 请选择发货方',
    labelOutmarket: '712 发货方',
    placeholderGoodsno: '713 请输入货号，多个用空格隔开',
    labelGoodsno: '714 货号',
    placeholderCreateuser: '715 请填写创建人',
    labelCreateuser: '716 创建人',
    placeholderCreatetime: '717 请选择创建时间',
    labelCreatetime: '718 创建时间',
    placeholderUpdatetime: '719 请选择更新时间',
    labelUpdatetime: '720 更新时间',
    btnSearch: '721 查询',
    btnReset: '722 重置',
    distributionStartcheck: '723 开始验收',
    distributionSelectpackagetitle: '724 请选择包裹号',
    distributionSelect: '725 选择',
    distributionPackagesn: '726 包裹号',
    distributionExpresssn: '727 包裹快递号',
    distributionLogisticsname: '728 物流公司',
    distributionCheckstate: '729 验收状态',
    stateUnchecked: '730 未验收',
    stateCheckingV1: '731 验收中',
    stateChecked: '732 已验收',
    distributionGoodsnum: '733 货品件数',
    distributionConfirm: '734 确 定',
    distributionPackagecheckedwarning: '735 该包裹已验收，无法选择！',
    distributionPackagerequired: '736 请选择包裹号',
    distributionTip: '737 提示',
    distributionRfidtip: '738 本单已通过RFID芯片进行出货，并且店铺已经开启了使用RFID芯片收货。请使用盘点机对本单进行收货！',
    distributionIknow: '739 知道了',
    transferslipenterStartcheck: '740 开始验收',
    transferslipenterSelectpackagetitle: '741 请选择包裹号',
    transferslipenterSelect: '742 选择',
    transferslipenterPackagesn: '743 包裹号',
    transferslipenterExpresssn: '744 包裹快递号',
    transferslipenterLogisticsname: '745 物流公司',
    transferslipenterCheckstate: '746 验收状态',
    stateUncheckedV1: '747 未验收',
    stateCheckingV2: '748 验收中',
    stateCheckedV1: '749 已验收',
    transferslipenterGoodsnum: '750 货品件数',
    transferslipenterConfirm: '751 确 定',
    transferslipenterPackagecheckedwarning: '752 该包裹已验收，无法选择！',
    transferslipenterPackagerequired: '753 请选择包裹号',
    transferslipenterTip: '754 提示',
    transferslipenterRfidtip: '755 本单已通过RFID芯片进行出货，并且店铺已经开启了使用RFID芯片收货。请使用盘点机对本单进行收货！',
    transferslipenterIknow: '756 知道了',
    allotpickupTitle: '757 拣货',
    allotpickupReceiver: '758 收货方',
    allotpickupInvoiceno: '759 单据号',
    allotpickupSubmitbutton: '760 完成拣货并提交',
    allotpickupScanplaceholder: '761 请扫码或输入条码',
    allotpickupConfirm: '762 确定',
    allotpickupNegativescan: '763 负扫',
    allotpickupPositivescan: '764 正扫',
    allotpickupShowonlyunpicked: '765 只显示未拣',
    allotpickupGoodsnoplaceholder: '766 请输入货号',
    allotpickupSearch: '767 查询',
    allotpickupScantrajectory: '768 扫码轨迹',
    allotpickupSealpacket: '769 封包',
    allotpickupAvailabletoseal: '770 可封',
    allotpickupClearpicknum: '771 清空拣货数量',
    allotpickupLastscanned: '772 刚刚扫码的货品：',
    allotpickupReceivedprefix: '773 已收',
    allotpickupPackageno: '774 包裹号',
    allotpickupPackagedcount: '775 打包件数',
    allotpickupEstimatedweight: '776 预估重量（kg）',
    allotpickupPacker: '777 打包人',
    allotpickupPacktime: '778 封包时间（创建）',
    allotpickupAction: '779 操作',
    allotpickupViewpackage: '780 查看包裹',
    allotpickupDissolvepackage: '781 解散包裹',
    allotpickupPrint: '782 打印',
    allotpickupGoodsname: '783 货品名称',
    allotpickupGoodsno: '784 货号',
    allotpickupMinpickwarning: '785 请至少拣货一件',
    allotpickupSuccess: '786 操作成功',
    allotpickupTip: '787 提示',
    allotpickupClearconfirm: '788 清空后货品需要重新拣货，确定清空?',
    allotpickupCurrentavailable: '789 当前可封包数为',
    allotpickupConfirmseal: ' ，确定封为一个包裹？',
    allotpickupSealpackagedialog: '791 封包',
    allotpickupNoavailabletoseal: '792 暂无可封包数量',
    allotpickupNoneedgoodsconfirm: '793 本单不需要拣该货品，确定继续拣货？',
    allotpickupNoneedsizeconfirm: '794 本单不需要拣该尺码，确定继续拣货？',
    allotpickupExceedquantityconfirm: '795 该货品拣货已超数量，确定继续拣货？',
    allotpickupBarcodeprefix: '796 条码：',
    allotpickupConfirmbutton: '797 确定',
    allotpickupCancelbutton: '798 取消',
    allotpickupCancelled: '799 已取消',
    checkacceptdrawerDrawertitle: '800 拣货',
    checkacceptdrawerReceiver: '801 收货方',
    checkacceptdrawerDocumentno: '802 单据号',
    checkacceptdrawerSubmitbutton: '803 完成拣货并提交',
    checkacceptdrawerScanplaceholder: '804 请扫码或输入条码',
    checkacceptdrawerConfirmbutton: '805 确定',
    checkacceptdrawerCancelbutton: '806 取消',
    checkacceptdrawerNegativescan: '807 负扫',
    checkacceptdrawerPositivescan: '808 正扫',
    checkacceptdrawerShowunpickedonly: '809 只显示未拣',
    checkacceptdrawerSkuplaceholder: '810 请输入货号',
    checkacceptdrawerSearchbutton: '811 查询',
    checkacceptdrawerScantrack: '812 扫码轨迹',
    checkacceptdrawerClearpick: '813 清空拣货数量',
    checkacceptdrawerProductname: '814 货品名称',
    checkacceptdrawerSkuno: '815 货号',
    checkacceptdrawerConfirmclear: '816 清空后货品需要重新拣货，确定清空?',
    checkacceptdrawerOperationsuccess: '817 操作成功',
    checkacceptdrawerPickatleastone: '818 请至少拣货一件',
    checkacceptdrawerConfirmoverpick: '819 本单不需要拣该货品，确定继续拣货？',
    checkacceptdrawerBarcodeprefix: '820 条码:',
    checkacceptdrawerOperationcancelled: '821 已取消',
    checkacceptdrawerLastscanned: '822 当前扫码货品',
    checkacceptdrawerTip: '823 提示',
    checkacceptdrawerColor: '824 颜色',
    checkacceptdrawerSize: '825 尺码',
    checkacceptdrawerQuantity: '826 数量',
    columnSn: '827 单号',
    columnStatedesc: '828 状态',
    stateDraft: '829 草稿单(蓝色)：临时保存单据草稿，不会占用库存',
    statePresubmit: '830 预提交（紫色）：先提交单据，但不会下发到店铺，会占用店铺库存',
    stateIssued: '831 已下发（绿色）：已提交单据，且下发到店铺，待店铺拣货出库',
    statePicking: '832 拣货中（橙色）：店铺收到指令，正在拣货',
    statePickcompleted: '833 拣货完成（绿色）：店铺拣货完成并提交',
    stateShipped: '834 已出货（蓝色）：店铺已按照退仓单拣货出库，会扣减店铺库存，物流状态在途，将增加仓库在途库存',
    stateSignedV1: '835 已签收（绿色）：走合作物流发货时，物流信息已到仓签收，等待仓库拆包验收',
    stateCheckingV3: '836 验收中（橙色）：仓库拆包验收中',
    stateStored: '837 已入库（绿色）：验收完成后，操作确认入库，仓库的在途库存变为实际增加库存',
    stateVoided: '838 已作废（红色）：草稿单、预提交、已下发，这三个状态可进行作废操作',
    stateVoidapplying: '839 申请作废（红色）：已出货单据进行申请作废',
    columnIfdiscrepancy: '840 收货差异待处理',
    columnYes: '841 是',
    columnNo: '842 否',
    columnMarketname: '843 发货方',
    columnWarehousename: '844 收货方',
    columnTotalnum: '845 计划数量',
    columnOutnum: '846 出货数量',
    columnOutpackagenum: '847 出货包裹数',
    columnOutnumdifference: '848 出货差异数',
    columnInnum: '849 入库数量',
    columnInnumdifference: '850 入库差异数',
    columnLogisticpackagechecknum: '851 入库包裹数',
    columnRemark: '852 备注',
    columnCreateusername: '853 创建人',
    columnCreatetime: '854 创建时间',
    columnUpdatetime: '855 更新时间',
    columnUpdateusername: '856 修改人',
    placeholderSn: '857 请输入单号',
    placeholderExpressnoV1: '858 请输入快递单号',
    placeholderStateV1: '859 请选择状态',
    labelSn: '860 单号',
    labelExpressnoV1: '861 快递单号',
    labelStateV1: '862 状态',
    optionsDraft: '863 草稿单',
    optionsIssued: '864 已下发',
    optionsPicking: '865 拣货中',
    optionsPickcompleted: '866 拣货完成',
    optionsPackcompleted: '867 打包完成',
    optionsShipped: '868 已出货',
    optionsSigned: '869 已签收',
    optionsChecking: '870 验收中',
    optionsStored: '871 已入库',
    optionsVoidapplying: '872 作废申请',
    optionsVoided: '873 已作废',
    labelIfdiscrepancyV1: '874 是否仅看收货差异待处理',
    placeholderSelectV1: '875 请选择',
    labelHasdiscrepancyV1: '876 是否有差异记录',
    placeholderWarehouse: '877 请选择收货方',
    placeholderGoodsnoV1: '878 请输入货号，多个用空格隔开',
    labelGoodsnoV1: '879 货号',
    placeholderCreateuserV1: '880 请填写创建人',
    labelCreateuserV1: '881 创建人',
    placeholderCreatetimeV1: '882 请选择创建时间',
    labelCreatetimeV1: '883 创建时间',
    placeholderUpdatetimeV1: '884 请选择更新时间',
    labelUpdatetimeV1: '885 更新时间',
    buttonQuery: '886 查询',
    buttonReset: '887 重置',
    columnGoodsname: '888 货品名称',
    columnGoodsno: '889 货号',
    columnColorvalue: '890 颜色',
    columnTotal: '891 汇总',
    sizeinfoUsablequantity: '892 可用库存',
    sizeinfoNumber: '893 退货数',
    actionsDel: '894 删除',
    footerTotalamount: '895 总款数',
    unitTotalamount: ' 个',
    footerTcgetnum: '897 退仓总件数',
    deptretreatadddialogTitle: '898 退仓单',
    deptretreatadddialogFillinfotitle: '899 请填写信息',
    deptretreatadddialogReceiverinfo: '900 收货方',
    deptretreatadddialogSelectwarehouse: '901 请选择仓库',
    deptretreatadddialogRemark: '902 备注',
    deptretreatadddialogRemarkplaceholder: '903 请填写备注信息',
    deptretreatadddialogAddgoodstitle: '904 新增货品明细',
    deptretreatadddialogInputgoodsno: '905 请输入货号，多个用空格隔开',
    deptretreatadddialogSearchbtn: '906 查 询',
    deptretreatadddialogCrosspageselect: '907 跨页全选',
    deptretreatadddialogConfirmadd: '908 确认添加',
    deptretreatadddialogAddedgoodstitle: '909 已添加货品列表',
    deptretreatadddialogScanbarcode: '910 请扫码或输入条码',
    deptretreatadddialogConfirmbtn: '911 确定',
    deptretreatadddialogNegativescan: '912 负扫',
    deptretreatadddialogPositivescan: '913 正扫',
    deptretreatadddialogInputgoodsnofilter: '914 请输入货号',
    deptretreatadddialogQuerybtn: '915 查询',
    deptretreatadddialogClearbtn: '916 清空',
    deptretreatadddialogViewscantrack: '917 查看扫码轨迹',
    deptretreatadddialogCurrentscangoods: '918 当前扫码货品',
    deptretreatadddialogGoodsno: '919 货号',
    deptretreatadddialogColor: '920 颜色',
    deptretreatadddialogSize: '921 尺码',
    deptretreatadddialogQuantity: '922 数量',
    deptretreatadddialogSavedraft: '923 存入草稿',
    deptretreatadddialogConfirmsubmit: '924 确认提交',
    deptretreatadddialogSelectgoodsfirst: '925 请选择货品再添加',
    deptretreatadddialogSelectreceiver: '926 请选择收货方',
    deptretreatadddialogFillretreatnum: '927 请填写退仓数',
    deptretreatadddialogFillremark: '928 请填写备注',
    deptretreatadddialogOperationsuccess: '929 操作成功',
    deptretreatadddialogQuantityoutofrange: '930 数量超出范围',
    deptretreatadddialogDeleteconfirm: '931 是否删除该条记录',
    deptretreatadddialogInputbarcode: '932 请输入条码',
    deptretreatadddialogInputcontent: '933 请输入内容',
    deptretreatadddialogGoodsname: '934 货号名称',
    deptretreatadddialogUsablestock: '935 可用库存',
    deptretreatadddialogtip: '936 提示',
    deptretreatdetailsTitle: '937 单据详情',
    deptretreatdetailsStartpicking: '938 开始拣货',
    deptretreatdetailsInvoiceinfotitle: '939 单据信息',
    deptretreatdetailsCreator: '940 创建人',
    deptretreatdetailsSender: '941 发货方',
    deptretreatdetailsReceiver: '942 收货方',
    deptretreatdetailsReturnquantity: '943 退货数量',
    deptretreatdetailsOutboundquantity: '944 出货数量',
    deptretreatdetailsInboundquantity: '945 入库数量',
    deptretreatdetailsOutbounddiff: '946 出货差异数',
    deptretreatdetailsInbounddiff: '947 入库差异数',
    deptretreatdetailsCreatetime: '948 创建时间',
    deptretreatdetailsUpdatetime: '949 更新时间',
    deptretreatdetailsLastmodifier: '950 最后修改人',
    deptretreatdetailsTotaltime: '951 总耗时',
    deptretreatdetailsGoodsresponsible: '952 商品负责人',
    deptretreatdetailsRemark: '953 备注',
    deptretreatdetailsGoodslisttitle: '954 商品列表',
    deptretreatdetailsShipmentinfotitle: '955 发货信息',
    deptretreatdetailsInvoiceno: '956 单号',
    deptretreatdetailsPackageno: '957 包裹号',
    deptretreatdetailsGoodsquantity: '958 货品数量',
    deptretreatdetailsSenderinfo: '959 发货方',
    deptretreatdetailsReceiverinfo: '960 收货方',
    deptretreatdetailsLogisticscompany: '961 物流公司',
    deptretreatdetailsTrackingno: '962 快递单号',
    deptretreatdetailsStatus: '963 状态',
    deptretreatdetailsPendingupdate: '964 待更新',
    deptretreatdetailsPackingcompletetime: '965 打包完成时间',
    deptretreatdetailsShipmenttime: '966 发货时间',
    deptretreatdetailsSigntime: '967 签收时间',
    deptretreatdetailsActions: '968 操作',
    deptretreatdetailsViewpackage: '969 查看包裹',
    deptretreatdetailsLogisticstrack: '970 物流轨迹',
    deptretreatdetailsEditinfo: '971 修改信息',
    deptretreatdetailsPrint: '972 打印',
    deptretreatdetailsDiffinfotitle: '973 收货差异信息',
    deptretreatdetailsConsignee: '974 收货人',
    deptretreatdetailsReceiptcompletetime: '975 收货完成时间',
    deptretreatdetailsOutboundlabelquantity: '976 出货标签数量',
    deptretreatdetailsDiscrepancy: '977 差异',
    deptretreatdetailsSenderresponsibility: '978 发货方责任',
    deptretreatdetailsReceiverresponsibility: '979 收货方责任',
    deptretreatdetailsTransportresponsibility: '980 运输方责任',
    deptretreatdetailsUndetermined: '981 未定责',
    deptretreatdetailsDetermined: '982 已定责',
    deptretreatdetailsViewdetails: '983 查看详情',
    deptretreatdetailsCancelapplicationtitle: '984 作废申请记录',
    deptretreatdetailsApplicant: '985 申请人',
    deptretreatdetailsApplicationtime: '986 申请时间',
    deptretreatdetailsApplicationreason: '987 申请理由',
    deptretreatdetailsApprover: '988 审批人',
    deptretreatdetailsApprovaltime: '989 审批时间',
    deptretreatdetailsPendingapproval: '990 待审批',
    deptretreatdetailsApproved: '991 已通过',
    deptretreatdetailsRejected: '992 已拒绝',
    deptretreatdetailsSelectpackagetitle: '993 请选择包裹号',
    deptretreatdetailsSelect: '994 请选择',
    deptretreatdetailsConfirm: '995 确 定',
    deptretreatdetailsNotcollected: '996 未揽收',
    deptretreatdetailsPendingshipment: '997 待发货',
    deptretreatdetailsIntransit: '998 运输中',
    deptretreatdetailsOutfordelivery: '999 配送中',
    deptretreatdetailsDelivered: '1000 已妥投',
    deptretreatdetailsUsepdaforpicking: '1001 请用PDA拣货',
    deptretreatdetailsConfirmcancelexpress: '1002 是否取消快递单',
    deptretreatdetailsCancelsuccess: '1003 取消成功',
    deptretreatdetailsSelectpackageno: '1004 请选择包裹号',
    deptretreatdetailsGoodsname: '1005 货品名称',
    deptretreatdetailsGoodsno: '1006 货号',
    deptretreatdetailsRetailprice: '1007 零售价',
    dissolvepackageDialogtitle: '1008 提示',
    dissolvepackageTitle: '1009 解散包裹',
    dissolvepackageOption: '1010 保留包裹货品的拣货数量，可继续拣货后再去操作封包',
    dissolvepackageOptionV1: '1011 清空包裹货品的拣货数量，本包裹的货品需要重新拣货',
    dissolvepackageCancelbtn: '1012 取 消',
    dissolvepackageConfirmbtn: '1013 确 定',
    endpackDialogtitlecompleteaccept: '1014 完成验收',
    endpackDialogtitlecompletepick: '1015 完成拣货并提交',
    endpackWarningmessage: '1016 当前数据存在差异，确定继续提交？',
    endpackTotalquantityV1: '1017 总数量：',
    endpackAcceptedquantity: '1018 已验收：',
    endpackPickedquantity: '1019 已拣货：',
    endpackExcessacceptedquantity: '1020 超验收：',
    endpackExcesspickedquantity: '1021 超拣货：',
    endpackUnacceptedquantity: '1022 未验收：',
    endpackUnpickedquantity: '1023 未拣货：',
    endpackDifreasonlabel: '1024 差异拣货的原因',
    endpackDifreasonplaceholder: '1025 请输入差异拣货的原因',
    endpackDifreasonrequired: '1026 请填写差异拣货原因',
    endpackCancelbtnV1: '1027 取 消',
    endpackConfirmbtnV1: '1028 确 定',
    outconfigGoodsno: '1029 货号',
    outconfigGoodscode: '1030 简码',
    outconfigGoodsname: '1031 名称',
    outconfigColorvalue: '1032 颜色',
    outconfigTotal: '1033 总数',
    packagedetailTitle: '1034 包裹明细',
    packagedetailSearchlabel: '1035 货号/条码/简码',
    packagedetailSearchplaceholder: '1036 输入后按回车搜索',
    packageepcphDialogtitleV2: '1037 提示',
    packageepcphDetailtitle: '1038 包裹明细',
    packageepcphGoodslabel: '1039 货号/条码/简码',
    packageepcphSearchplaceholderV1: '1040 输入后按回车搜索',
    packageepcphEpcsearchplaceholder: '1041 输入后按回车搜索',
    packageepcphGoodstabV2: '1042 货品',
    packageepcphTotallabelV1: '1043 总计',
    packageepcphTotalamountV1: '1044 总款数',
    packageepcphTotalquantity: '1045 总件数',
    packageepcphTablegoodsno: '1046 货号',
    packageepcphTablegoodsname: '1047 货品名称',
    packageepcphTablecolor: '1048 颜色',
    packageepcphTablesize: '1049 尺码',
    packageepcphTablenumber: '1050 数量',
    packageepcphTablesum: '1051 总数',
    printdocumentsTitle: '1052 打印单据',
    printdocumentsPrintbtn: '1053 打印',
    printdocumentsAllottitle: '1054 店铺调拨单',
    printdocumentsReturntitle: '1055 店铺退仓单',
    printdocumentsScantip: '1056 扫码可快速定位单据',
    printdocumentsInvoicedate: '1057 单据日期：',
    printdocumentsInvoiceno: '1058 单据编号：',
    printdocumentsOutmarket: '1059 调出店铺：',
    printdocumentsReturnmarket: '1060 退出店铺：',
    printdocumentsInmarket: '1061 调入店铺：',
    printdocumentsReturnwarehouse: '1062 退入仓库：',
    printdocumentsGoodsno: '1063 货号',
    printdocumentsColor: '1064 颜色',
    printdocumentsSize: '1065 尺码',
    printdocumentsQuantity: '1066 数量',
    printdocumentsTotalquantity: '1067 合计数量：',
    printdocumentsGoodsname: '1068 货品名称',
    printdocumentsDistributiontitle: '1069 商品铺货单',
    printdocumentsAlloutouttitle: '1070 店铺调出单',
    printdocumentsReturntitleV2: '1071 店铺退货单',
    printdocumentsReturnsuppliertitle: '1072 店铺退供单',
    returnpickupDrawertitle: '1073 拣货',
    returnpickupReceiverlabel: '1074 收货方',
    returnpickupInvoicesnlabel: '1075 单据号',
    returnpickupSubmitbutton: '1076 完成拣货并提交',
    returnpickupScanplaceholder: '1077 请扫码或输入条码',
    returnpickupConfirmbutton: '1078 确定',
    returnpickupNegativescan: '1079 负扫',
    returnpickupPositivescan: '1080 正扫',
    returnpickupOnlyunpicked: '1081 只显示未拣',
    returnpickupGoodsnoplaceholder: '1082 请输入货号',
    returnpickupSearchbutton: '1083 查询',
    returnpickupScantrajectory: '1084 扫码轨迹',
    returnpickupSealpacket: '1085 封包',
    returnpickupClearbutton: '1086 清空拣货数量',
    returnpickupRecentscan: '1087 刚刚扫码的货品',
    returnpickupReceivedcount: '1088 已收',
    returnpickupPackagesn: '1089 包裹号',
    returnpickupPackagecount: '1090 打包件数',
    returnpickupEstimatedweight: '1091 预估重量（kg）',
    returnpickupPacker: '1092 打包人',
    returnpickupPacktime: '1093 封包时间（创建）',
    returnpickupAction: '1094 操作',
    returnpickupViewpackage: '1095 查看包裹',
    returnpickupDissolvepackage: '1096 解散包裹',
    returnpickupPrint: '1097 打印',
    returnpickupClearconfirm: '1098 清空后货品需要重新拣货，确定清空?',
    returnpickupConfirmtitle: '1099 提示',
    returnpickupSuccessmessage: '1100 操作成功',
    returnpickupNopackagequantity: '1101 暂无可封包数量',
    returnpickupAvailablepackage: '1102 当前可封包数为',
    returnpickupConfirmseal: ' ，确定封为一个包裹？',
    returnpickupSealtitle: '1104 封包',
    returnpickupExceedgoodsconfirm: '1105 本单不需要拣该货品，确定继续拣货？',
    returnpickupExceedsizeconfirm: '1106 本单不需要拣该尺码，确定继续拣货？',
    returnpickupExceednumberconfirm: '1107 该货品拣货已超数量，确定继续拣货？',
    returnpickupConfirmaction: '1108 确定',
    returnpickupCancelaction: '1109 取消',
    returnpickupCancelledmessage: '1110 已取消',
    returnpickupMinpickerror: '1111 请至少拣货一件',
    returnpickupGoodsname: '1112 货品名称',
    returnpickupGoodsno: '1113 货号',
    returnpickupAvailableseal: '1114 可封',
    returnpickupBarcodelabel: '1115 条码',
    tableconfigGoodsnameV2: '1116 货品名称',
    tableconfigGoodsnowithimageV2: '1117 货号 (点击查看图片)',
    tableconfigColorV2: '1118 颜色',
    tableconfigTotalV2: '1119 汇总',
    tableconfigTotalnumber: '1120 总数',
    tableconfigPicked: '1121 已拣',
    tableconfigPackaged: '1122 封包',
    tableconfigOverpicked: '1123 超拣',
    tableconfigUnpicked: '1124 未拣',
    tableconfigTotalitemsV2: '1125 总件数',
    tableconfigReturnquantityV1: '1126 退仓数量',
    tableconfigOutboundquantity: '1127 出货数量',
    tableconfigOutbounddifference: '1128 出货差异',
    tableconfigInboundquantity: '1129 入库数量',
    tableconfigInbounddifference: '1130 入库差异',
    tableconfigTotalreturnitems: '1131 退仓总件数',
    tableconfigTotaloutbounddifference: '1132 出货差异总数',
    tableconfigTotalinbounddifference: '1133 入库差异总数',
    tableconfigShortcodeV2: '1134 简码',
    tableconfigGoodsnoV2: '1135 货号',
    tableconfigQuantityV2: '1136 数量',
    tableconfigTotaltypes: '1137 总款数',
    tableconfigTotalgoodscount: '1138 货品总数',
    deptretreatPrintbtn: '1139 打印单据',
    deptretreatStartpickbtn: '1140 开始拣货',
    deptretreatEnterexpressbtn: '1141 录入快递信息',
    deptretreatSubmitbtn: '1142 提交',
    deptretreatCopybtn: '1143 复制单据',
    deptretreatRollbackpickbtn: '1144 回退拣货',
    deptretreatReorderbtn: '1145 重新做单',
    deptretreatAddnewbtn: '1146 新增店铺退货单',
    deptretreatConfirmtitle: '1147 提示',
    deptretreatReorderconfirm: '1148 此单是否重新做单',
    deptretreatSuccessmsg: '1149 操作成功',
    deptretreatSubmitconfirm: '1150 确定后单据将变为打包完成状态，确定提交？',
    deptretreatMarkpackcompleted: '1151 标记为打包完成',
    deptretreatCopyconfirm: '1152 是否复制此单据',
    deptretreatCopyoperation: '1153 复制',
    deptretreatPdapickwarning: '1154 请用PDA拣货',
    deptretreatrepickComfirmTip: '1155 此单确定回到“拣货中”状态继续拣货?',
    deptretreatrepickTip: '1156 提示',
    deptretreatrepickActionSuccess: '1157 操作成功',
    dialogconfigEdittransfertitle: '1158 编辑店铺调拨单',
    dialogconfigAddtransfertitle: '1159 新增店铺调拨单',
    dialogconfigEditreturntitle: '1160 编辑店铺退仓单',
    dialogconfigAddreturntitle: '1161 新增店铺退仓单',
    transferconfigColumnsn: '1162 单号',
    transferconfigColumnstate: '1163 状态',
    transferconfigStatedraftdesc: '1164 草稿单(蓝色)：临时保存单据草稿，不会占用库存',
    transferconfigStateissueddesc: '1165 已下发（绿色）：已提交单据，且下发到店铺，待店铺拣货出库',
    transferconfigStatepickingdesc: '1166 拣货中（橙色）：店铺收到指令，正在拣货',
    transferconfigStatepickeddesc: '1167 拣货完成（绿色）：店铺拣货完成并提交',
    transferconfigStateshippeddesc: '1168 已出货（蓝色）：店铺已按照调拨单拣货出库，会扣减店铺库存，物流状态在途，将增加店铺在途库存',
    transferconfigStatesigneddesc: '1169 已签收（绿色）：走合作物流发货时，物流信息已到店签收，等待店铺拆包验收',
    transferconfigStatecheckingdesc: '1170 验收中（橙色）：店铺拆包验收中',
    transferconfigStatestoreddesc: '1171 已入库（绿色）：验收完成后，操作确认入库，店铺的在途库存变为实际增加库存',
    transferconfigStatecanceleddesc: '1172 已作废（红色）：草稿单、预提交、已下发，这三个状态可进行作废操作',
    transferconfigStatecancelapplydesc: '1173 申请作废（红色）：已出货单据进行申请作废',
    transferconfigColumndiscrepancy: '1174 收货差异待处理',
    transferconfigYestext: '1175 是',
    transferconfigNotext: '1176 否',
    transferconfigColumnoutmarket: '1177 发货方',
    transferconfigColumninmarket: '1178 收货方',
    transferconfigColumnplannum: '1179 计划数量',
    transferconfigColumnoutnum: '1180 出货数量',
    transferconfigColumnoutpackage: '1181 出货包裹数',
    transferconfigColumnoutdiff: '1182 出货差异数',
    transferconfigColumndiffreason: '1183 差异拣货原因',
    transferconfigColumninnum: '1184 入库数量',
    transferconfigColumninpackage: '1185 入库包裹数',
    transferconfigColumnindiff: '1186 入库差异数',
    transferconfigColumnremark: '1187 备注',
    transferconfigColumncreator: '1188 创建人',
    transferconfigColumncreatetime: '1189 创建时间',
    transferconfigColumnupdatetime: '1190 更新时间',
    transferconfigColumnmodifier: '1191 修改人',
    transferconfigPlaceholdersn: '1192 请输入单号',
    transferconfigLabelsn: '1193 单号',
    transferconfigPlaceholderexpress: '1194 请输入快递单号',
    transferconfigLabelexpress: '1195 快递单号',
    transferconfigPlaceholderstate: '1196 请选择状态',
    transferconfigLabelstate: '1197 状态',
    transferconfigStatedraft: '1198 草稿单',
    transferconfigStateissued: '1199 已下发',
    transferconfigStatepicking: '1200 拣货中',
    transferconfigStatepicked: '1201 拣货完成',
    transferconfigStatepacked: '1202 打包完成',
    transferconfigStateshipped: '1203 已出货',
    transferconfigStatesigned: '1204 已签收',
    transferconfigStatechecking: '1205 验收中',
    transferconfigStatestored: '1206 已入库',
    transferconfigStatecancelapply: '1207 作废申请',
    transferconfigStatecanceled: '1208 已作废',
    transferconfigPlaceholderselect: '1209 请选择',
    transferconfigLabeldiscrepancy: '1210 是否仅看收货差异待处理',
    transferconfigLabelhasdiscrepancy: '1211 是否有差异记录',
    transferconfigPlaceholderinmarket: '1212 请选择收货方',
    transferconfigPlaceholdergoodsno: '1213 请输入货号，多个用空格隔开',
    transferconfigLabelgoodsno: '1214 货号',
    transferconfigPlaceholdercreator: '1215 请填写创建人',
    transferconfigLabelcreatorsearch: '1216 创建人',
    transferconfigPlaceholdercreatetime: '1217 请选择创建时间',
    transferconfigPlaceholderupdatetime: '1218 请选择更新时间',
    transferconfigBtnsearch: '1219 查询',
    transferconfigBtnreset: '1220 重置',
    transferslipoutPrintdocuments: '1221 打印单据',
    transferslipoutStartpicking: '1222 开始拣货',
    transferslipoutEnterexpressinfo: '1223 录入快递信息',
    transferslipoutSubmit: '1224 提交',
    transferslipoutCopydocuments: '1225 复制单据',
    transferslipoutRollbackpicking: '1226 回退拣货',
    transferslipoutRedoorder: '1227 重新做单',
    transferslipoutAddnewstoretransfer: '1228 新增店铺调拨单',
    transferslipoutPleaseusepdapicking: '1229 请用PDA拣货',
    transferslipoutConfirmredoorder: '1230 此单是否重新做单',
    transferslipoutOperationsuccess: '1231 操作成功',
    transferslipoutConfirmsubmitforpackcomplete: '1232 确定后单据将变为打包完成状态，确定提交？',
    transferslipoutMarkaspackcomplete: '1233 标记为打包完成',
    transferslipoutConfirmvoiddocuments: '1234 是否将单据操作为作废',
    transferslipoutVoidoperation: '1235 作废',
    transferslipoutConfirmcopydocuments: '1236 是否复制此单据',
    transferslipoutCopyoperation: '1237 复制',
    transferslipoutConfirmreturntopicking: '1238 此单确定回到“拣货中”状态继续拣货?',
    transferslipoutConfirmTip: '1239 提示',
    indexInvoicescenter: '1240 单据中心',
    indexReceiving: '1241 收货',
    indexUnwarehouseinvoicescounthint: '1242 数字统计的是【未入库】单据的数量',
    indexStorereceipt: '1243 店铺收货单',
    indexStoretransferin: '1244 店铺调入单',
    indexShipping: '1245 出货',
    indexUnshippedinvoicescounthint: '1246 数字统计的是【未出货】单据的数量',
    indexStorereturnwarehouse: '1247 店铺退仓单',
    indexStoretransferout: '1248 店铺调出单',
  },

  deptStock: {
    createApplySent:'1351 您的申请已发送',
    commonConfirm:'确认',
    createUseScanner:'1353 请通过盘点机操作盘点',
    createArea:'1354 * 区域：',
    areaPleaseSelect:'1355 请选择区域',
    createAddDetail:'1356 添加明细',
    createCompleted:'1357 该盘点单已完成不能继续添加明细',
    createViewRecord:'1358 查看盘点记录',
    applyStock:'申请盘点',
    addStock:'1360 新建盘点单',
    addStockDetail:'1361 添加明细',
    waitCreateStock:'1362 等待后台创建盘点单',
    stockDate:'1363 盘点时间',
    stockStartDate:'1364 开始日期',
    stockEndDate:'1365 结束日期',
    stockDescript:'1366 盘点说明',
    pleaseInput:'1367 请输入',
    applyIsSend:'1368 您的申请已发送',
    pleaseUsePdaStock:'1369 请通过盘点机操作盘点',
    area:'1370 区域',
    pleaseArea:'1371 请选择区域',
    stockFinish:'1372 该盘点单已完成',
    notAddDetail:'1373 不能继续添加明细',
    validateSelectTime:'1374 请先选择时间！',
    validateFillDesc:'1375 请先填写盘点说明！',
    validateFillName:'1376 请填写盘点单名称',
    validateSelectCategory:'1377 请选择分类',
    createSuccess:'1378 盘点单创建成功',
    validateSelectArea:'1379 请选择区域',
    startInventory:'开始盘点',
    inventoryRecord:'盘点记录',
    pleaseScanOrInputBarcode:'1382 请扫码或输入条码',
    selectGoodsToAdd:'1383 选择货品添加',
    clearAll:'1384 清空',
    totalItems:'1385 明细总件数：{count}件',
    submitDetails:'1386 提交明细',
    barcodeInventory:'条码盘点',
    barcodeQuery:'条码查询',
    pleaseInputBarCodeMultipleWithSpace:'1389 请输入条码,多个用空格隔开',
    query:'查询',
    sortIndex:'序号',
    leftBarCode:'1392 条码',
    leftStockNumber:'1393 盘点数量',
    leftAction:'1394 操作',
    loadingText:'1395 正在加载中，请稍后...',
    confirmTips:'1396 提示',
    addBtn:'添加',
    goodsCode:'1398 简码',
    goodsNoSummary:'1399 货号汇总',
    goodsNo:'1400 货号',
    pleaseInputGoodsNoMultipleWithSpace:'1401 请输入货号，多个用空格隔开',
    inventoryDetailInfo:'盘点明细单信息',
    totalInventoryItems:'1403 盘点总件数：{count}件',
    remarks:'1404 备注',
    pleaseInputContent:'1405 请输入内容',
    selectToAdd:'1406 选择添加',
    barcodeGoodsNoNameCode:'1407 条码/货号/货品名称/简码',
    search:'1408 搜索',
    selectSpecification:'1409 选择规格',
    selected:'已选择',
    color:'颜色',
    size:'尺码',
    code:'码',
    cancel:'1414 取消',
    confirm:'1415 确定',
    pleaseDoubleClickLockToUnlock:'1416 请双击最左边的“锁”解锁',
    pleaseAddDetailsFirst:'1417 请先添加明细再提交',
    confirmClearAll:'1418 是否清空记录？',
    confirmClearDataOnSwitch:'1419 当前正在盘点切换后本次盘点数据将会清空，是否确认',
    positiveScan:'1420 正扫',
    negativeScan:'1421 负扫',
    positiveScanMin:'1422 正扫时最小值为1，不能再减了',
    negativeScanMax:'1423 负扫时最大值为-1，不能再加了',
    inventoryQuantityCannotBeNegative:'1424 盘点数量不能为负数',
    pleaseInputPositiveInteger:'1425 请填写大于0的整数',
    deleteCurrentEffectRight:'1426 删除当前记录右侧数量也会相应变化,是否删除？',
    operationSuccess:'1427 操作成功！',
    submitSuccess:'1428 提交成功',
  },
  stockRecord: {
    inventoryRecord:'盘点记录',
    placeholderSerialNumber:'1430 请输入盘点编号',
    serialNumber:'1431 盘点编号',
    placeholderSerialName:'1432 请输入盘点单名称',
    serialName:'1433 盘点单名称',
    placeholderCreateTime:'1434 请选择创建时间',
    createTime:'1435 创建时间',
    userName:'1437 创建人',
    placeholderUserName:'1436 请输入创建人名称',
    placeholderSelect:'1438 请选择',
    mode:'1439 盘点方式',
    modeScan:'1440 扫码盘点',
    modeRfid:'1441 RFID 盘点',
    state:'1442 状态',
    inProgress:'1443 正在盘点',
    invalid:'1444 已作废',
    submitted:'1445 已提交',
    reviewing:'1446 过账审核',
    posted:'1447 已过账',
    btnSearch:'1448 查询',
    btnReset:'1449 重置',
    loadingText:'1450 请稍后，全力加载中...',
    deptName:'1451 部门名称',
    inventoryName:'1452 盘点单名称',
    seq:'1453 记录编号',
    typeDesc:'1454 盘点类型',
    tableMode:'1455 盘点方式',
    tableState:'1456 状态',
    // userName:'1457 创建人',
    // createTime:'1458 创建时间',
    finishTime:'1459 完盘时间',
    reviewTime:'1460 审核时间',
    detailCount:'1461 明细单数',
    goodsNoCount:'1462 款数量',
    goodsCount:'1463 货品数量',
    unrecognizedCount:'1464 无法识别数量',
    tableAction:'1465 操作',
    invalidate:'本单作废',
    restore:'恢复本单',
    resetOne:'单款重盘',
    finish:'完成盘点',
    diffDetail:'差异明细',
    compareDiff:'对比差异',
    viewDetail:'查看明细',
    invalidateContent:'1473 是否将该盘点单作废？',
    finishConfirm:'1474 是否将该盘点单标记完成，完成后将不能再继续添加明细单？',
    confirmRestore:'1475 是否将该盘点单恢复正常？',
    messageSuccess:'1476 操作成功',
    messageError:'1477 操作失败提示（原错误信息占位）',
  },
  stockDetail: {
    inventoryTitle:'1478 【盘点单】',
    inventoryInventoryName:'1479 盘点单名称',
    inventoryCreateTime:'1480 创建时间',
    inventoryTypeDesc:'1481 盘点类型',
    inventoryFinishTime:'1482 完盘时间',
    inventoryDeptName:'1483 店铺',
    inventoryReviewTime:'1484 审核时间',
    inventoryStateDesc:'1485 状态',
    inventoryUserName:'1486 创建人',
    inventoryTotal:'1487 盘点汇总',
    inventoryDetail:'1488 明细单',
    pleaseInput:'1489 请输入',
    queryGoodsNo:'1490 货号',
    chooseGoodsNo:'1491 请选择货号',
    queryCreateUser:'1492 创建人',
    placeholderUserName:'1493 请输入创建人名称',
    queryButton:'1494 查 询',
    summaryTotal:'1495 汇总',
    summaryInventoryNumber:'1496 盘点数量',
    summaryInventoryPrice:'1497 盘点金额',
    summaryPageTotal:'1498 本页汇总',
    detailSerialNumber:'1499 明细编号',
    detailCreateUserName:'1500 创建人',
    detailCreateTime:'1501 创建时间',
    detailState:'1502 状态',
    detailNormal:'1503 正常',
    detailVoided:'1504 已作废',
    detailRemarks:'1505 备注',
    detailGoodsName:'1506 货品名称',
    detailColor:'1507 颜色',
    detailSize:'1508 尺码',
    detailTagPrice:'1509 吊牌价',
    recoverInvoice:'1510 恢复本单',
    voidInvoice:'1511 本单作废',
    finishInvoice:'1512 完成盘点',
    detailVoid:'1513 作废',
    detailRecove:'1514 恢复',
    confirmRecover:'1515 确定恢复该盘点单',
    confirmVoid:'1516 确定作废该盘点单',
    confirmFinish:'1517 确定将该盘点单标记为完成盘点',
    confirmDetailVoid:'1518 确定将该明细单作废',
    confirmDetailRecove:'1519 确定恢复该明细单',
    confirmTitle:'1520 提示',
    messageSuccess:'1521 操作成功',
    messageError:'1522 操作失败',
    messageLoading:'1523 请稍后，全力加载中...',
    messageEmpty:'1524 该盘点单还没有盘点数据',
  },
  stockDiffer: {
    belongInventory:'1525 所属盘点单',
    stockDifferTitle:'1526 盘点差异',
    accountTitle:'1527 汇总',
    stockTotal:'1528 盘点总数',
    inventoryTotal:'1529 库存总数',
    summaryPageTotal:'1530 本页汇总',
    summaryInventoryPrice:'1531 盘点金额',
    inventorySerial:'1532 盘点单编号',
    totalDifference:'1533 差异总数',
    totalDifferencePrice:'1534 差异总金额',
    totalCompensate:'1535 赔付总金额',
    pageTotalDifference:'1536 当前页差异总数',
    pageTotalDifferencePrice:'1537 当前页差异总金额',
    pageTotalCompensate:'1538 当前页赔付金额',
    pleaseSelect:'1539 请选择',
    differenceType:'1540 差异类型',
    hasDifference:'1541 有差异',
    noDifference:'1542 无差异',
    selectIsChange:'1543 是否修改',
    isYse:'1544 是',
    isNo:'1545 否',
    materialNo:'1546 货号',
    enterMaterialNo:'1547 请输入货号模糊查询',
    styleCategory:'1548 款式分类',
    styleType:'1549 风格分类',
    timeCategory:'1550 时间分类',
    scanArea:'1551 扫描区域',
    query:'1552 查询',
    reset:'1553 重置',
    area:'1554 区域',
    firstStyleCategory:'1555 一级款式分类',
    secondStyleCategory:'1556 二级款式分类',
    thirdStyleCategory:'1557 三级款式分类',
    firstStyleType:'1558 一级风格分类',
    secondStyleType:'1559 二级风格分类',
    thirdStyleType:'1560 三级风格分类',
    firstTimeCategory:'1561 一级时间分类',
    secondTimeCategory:'1562 二级时间分类',
    thirdTimeCategory:'1563 三级时间分类',
    goodsName:'1564 货品名称',
    inventoryQuantity:'1565 盘点数量',
    stockQuantity:'1566 库存数量',
    retailPrice:'1567 当前销售价',
    price:'1568 价格',
    compensatePriceType:'1569 赔付价格类型',
    tagPrice:'1570 吊牌价',
    compensateFormula:'1571 赔付公式',
    compensateAmount:'1572 赔付金额',
    differenceQuantity:'1573 差异数量',
    allColor: '全部颜色',
    stockAccount: '盘点数量',
    saveChange: '3404 保存修改',
    viewChange : '3405 查看修改',
    placeholderNumberTips: '3406 请填写有效数字',
    youNotChangeData: '3407 您还没有修改数据',
    saveSuccessTip: '3408 保存成功',
  },
  stockSingle: {
    singleRediscTitle:'1574 单款重盘',
    singleRediscInventoryOrderPrefix:'1575 盘点单',
    singleRediscScanPlaceholder:'请扫码或输入条码',
    singleRediscConfirm:'确定',
    singleRediscNegativeScan:'1578 负扫',
    singleRediscPositiveScan:'1579 正扫',
    singleRediscSelectDiffGoods:'1580 选择盘点差异货品',
    singleRediscManualAddPlaceholder:'1581 请输入货号 / 简码 / 条码手动添加',
    singleRediscAddDirectly:'1582 直接添加',
    singleRediscTotalQuantity:'1583 总数量',
    singleRediscSubmit:'1584 确定提交',
    singleRediscDeleteFirst:'1585 请先删除当前款再选择',
    singleRediscSelectOrAddFirst:'1586 请先选择盘点差异货品或手动添加',
    singleRediscTips:'1587 提示',
    singleRediscBarcodeNotFound:'1588 当前货号没有找到该条码',
    singleRediscConfirmDelete:'1589 是否删除这条记录',
    singleRediscEnterInfo:'1590 请输入货号 / 简码 / 条码',
    singleRediscAddGoodsFirst:'1591 您还未添加货品，请先添加',
    singleRediscQuantityCannotBeZero:'1592 本次重盘数不能为 0',
    singleRediscSubmitSuccess:'1593 提交成功',
    selectInventoryDiffProduct: '3468 选择盘点差异货品',
    styleCategory: '3469 款式分类',
    pleaseSelectStyleCategory: '3470 请选择款式分类',
    styleType: '3471 风格分类',
    pleaseSelectStyleType: '3472 请选择风格分类',
    timeCategory: '3473 时间分类',
    pleaseSelectTimeCategory: '3474 请选择时间分类',
    productNoOrShortCode: '3475 货号 / 简码',
    pleaseInputProductNoOrShortCode: '3476 请输入货号 / 简码',
    query: '3477 查 询',
    cancel: '3478 取 消',
    confirm: '3479 确 定',
    productNo: '3480 货号',
    productName: '3481 货品名称',
    shortCode: '3482 简码',
    color: '3483 颜色',
    inventoryQuantity: '3484 盘点数量',
    stockQuantity: '3485 库存数量',
    diffQuantity: '3486 差异数量',
    retailPrice: '3487 零售价',
    total: '3488 总计',
    recheckQuantity: '重盘数',
    originalCheckQuantity: '原盘数',
    delete: '3491 删除',
  },
  differDetail: {
    diffDetails: '3492 差异明细',
    pleaseWaitLoading: '3493 请稍后，全力加载中...',
    inventoryOrderName: '3494 盘点单名称',
    inventoryOrderType: '3495 盘点单类型',
    storeName: '3496 店铺名称',
    status: '3497 状态',
    createTime: '3498 创建时间',
    completeInventoryTime: '3499 完盘时间',
    auditTime: '3500 审核时间',
    creator: '3501 创建人',
    totalInventoryQuantity: '3502 盘点总数',
    totalStockQuantity: '3503 库存总数',
    totalDiffQuantity: '3504 差异总数',
    totalCompensationAmount: '3505 赔付总金额',
    productNo: '3506 货号',
    pleaseSelectProductNo: '3507 请选择货号',
    query: '3508 查 询',
    productName: '3509 货品名称',
    styleCategory: '3510 款式分类',
    timeCategory: '3511 时间分类',
    color: '3512 颜色',
    unitPrice: '3513 单价',
    diffQuantity: '3514 差异数量',
    compensationAmount: '3515 赔付金额',
    beforeInventory: '盘点前',
    adjustmentQuantity: '调整数量',
    currentPageTotalDiffQuantity: '3518 本页总差异数',
    currentPageTotalCompensationAmount: '3519 本页总赔付金额',
  },
  performance: {
    title: '1594 业绩日历',
    separator: '1595 至',
    startPlaceholder: '1596 开始日期',
    endPlaceholder: '1597 结束日期',
    query: '1598 查 询',
    deptSales: '1599 门店业绩',
    totalSales: '1600 总业绩',
    customerUnitPrice: '1601 客单价',
    unitPrice: '1602 件单价',
    joinRate: '1603 连带率',
    challengeTarget: '1604 挑战目标',
    totalIncome: '1604 总收入',
    userSales: '1605 导购业绩',
    viewMonthPerformance: '1606 查看本月业绩',
    monthSelectorLabel: '1607 选择月份：',
    monthSelectorPlaceholder: '1608 请选择月份',
    salse: '{name}~{year}年{month}月业绩',
    viewTeamSales: '1610 查看公单业绩',
    viewDeptSales: '1611 查看店铺业绩',
    monday: '1612 星期一',
    tuesday: '1613 星期二',
    wednesday: '1614 星期三',
    thursday: '1615 星期四',
    friday: '1616 星期五',
    saturday: '1617 星期六',
    sunday: '1618 星期天',
    dailySales: '1619 业绩：',
    loadingText: '1620 请稍后，全力加载中...',
    publicTitle: '1621 公单业绩',
    close: '1622 关闭',
    labelName: '1623 姓名',
    placeholderName: '1624 请输入姓名',
    innerSn: '1625 单号',
    placeholderInnerSn: '1626 请输入单号',
    labelDate: '1627 日期',
    placeholderStartDate: '1628 开始时间',
    placeholderEndDate: '1629 结束时间',
    reset: '1630 重 置',
    search: '1631 查 询',
    date: '1632 日期',
    ruleName: '1633 公单规则名称',
    // innerSn: '1634 单号',
    orderPrice: '1635 公单总业绩',
    realName: '1636 姓名',
    postName: '1637 分配时职级',
    proportion: '1638 分配时份额',
    userAmount: '1639 个人分配业绩',
    summary: '1640 汇总',
  },
  musicPlayer: {
    title: '1336 店铺音乐台',
    noSongName: '1337 暂无歌曲名称',
    noSongListName: '1338 暂无歌单名称',
    noSinger: '1339 暂无歌手',
    playlist: '1340 播放列表',
    audioLoadError: '1341 音频加载异常',
    audioPlayError: '1342 音频播放异常',
    noPlayableMusic: '1343 当前没有可播放音乐',
    noSongs: '1344 暂无歌曲',
    doublePlayer: '1345 双击歌曲名称开始播放',
    musicName: '1346 歌曲名称',
    singList: '1347 歌单',
    singer: '1348 歌手',
    duration: '1349 时长',
    invalid: '1350 该歌曲已失效',
  },
  salesRecord: {
    salesRecord:'2927 销售记录',
    hangRecord:'2928 挂单记录',
    loadingText:'2929 请稍后，全力加载中...',
    afterSales:'2930 售后',
    goodsInfo:'货品信息',
    afterSalesGoodsInfo:'2932 售后做单的货品信息',
    totalItems:'2933 总件数：{count}件',
    totalAmount:'2934 总金额',
    original:'2935 原始',
    originalGoodsInfo:'2936 未发生售后之前，本单的货品信息',
    collapse:'2937 收起',
    expand:'2938 展开',
    latest:'2939 最新',
    latestGoodsInfo:'2940 已产生售后，本单的货品信息',
    documentInfo:'单据信息',
    orderAmount:'2942 本单应收(含增值税)',
    taxPrice:'2942 税金',
    retailAmount:'2943 零售金额：',
    receivedAmount:'2944 已收金额',
    activityAmount:'2945 活动金额',
    changeAmount:'2946 变动金额',
    salesStatus:'2947 销售状态',
    cancelled:'2948 已取消',
    pendingPayment:'2949 待支付',
    paying:'支付中',
    paid:'2951 已支付',
    pendingApproval:'2952 待审批',
    pending:'2953 已挂起',
    invalidated:'2954 已作废',
    storeName:'2955 店铺名称',
    giftInfo:'2956 赠品信息',
    documentSource:'2957 单据来源',
    mobile:'2958 手机端',
    client:'2959 客户端',
    orderNature:'2960 订单性质',
    salesOrderNo:'2961 销售单号',
    originalSalesOrderNo:'2962 原销售单号',
    externalOrderNo:'2963 外部单号',
    performanceMethod:'2964 业绩方式',
    personalPerformance:'2965 个人业绩',
    teamPerformance:'2966 班组业绩',
    distribution:'2967 分销',
    salesperson:'2968 营业员',
    creationTime:'2969 创建时间',
    teamMembers:'2970 班组人员',
    createOrderCashier:'2971 创建订单收银台',
    endOrderCashier:'2972 结束订单收银台',
    promotionInfo:'促销信息',
    promotion:'2974 促销',
    promotionName:'2975 促销名称',
    promotionType:'2976 促销类型',
    promotionNo:'2977 促销编号',
    discountAmount:'2978 减扣金额',
    promotionDetails:'2979 促销单详情',
    viewDetails:'2980 查看详情',
    memberInfo:'2981 会员信息',
    memberNickname:'2982 会员昵称',
    memberCardNo:'2983 会员卡号',
    totalConsumptionAmount:'2984 累计消费金额',
    unitPrice:'2985 件单价：',
    cardOpeningTime:'2986 开卡时间',
    totalConsumptionCount:'2987 累计消费次数',
    memberPoints:'2988 会员积分',
    phoneNumber:'2989 手机号',
    cardIssuingStore:'2990 开卡店铺',
    averageConsumptionAmount:'2991 平均消费金额',
    memberBalance:'2992 会员余额',
    paymentInfo:'收款信息',
    paymentMethod:'2994 收款方式',
    paymentAmount:'2995 收款金额',
    paymentStatus:'2996 支付状态',
    created:'2997 已创建',
    cancelledPay:'2998 已取消',
    pendingPay:'2999 支付中',
    updateTime:'3000 更新时间',
    paymentVoucherNo:'3001 支付凭证号',
    serialNumber:'3002 流水号',
    couponName:'3003 优惠券名称',
    couponType:'3004 优惠券类型',
    couponSource:'3005 优惠券来源',
    couponDiscountAmount:'3006 优惠金额',
    operation:'3007 操作',
    receiptPreview:'小票预览',
    approvalInfo:'3009 审批信息',
    approvalNo:'3010 审批编号',
    processType:'3011 流程类型',
    status:'3012 状态',
    withdrawn:'3013 已撤回',
    approved:'3014 已通过',
    rejected:'3015 已拒绝',
    pendingReview:'3016 待审核',
    initiator:'3017 发起人',
    submissionTime:'3018 提交时间',
    lastUpdateTime:'最新货品信息',
    approver:'3020 审批人',
    rejectionReason:'3021 拒绝原因',
    approvalDetails:'3022 审批详情',
    afterSalesInfo:'售后信息',
    afterSalesType:'3024 售后类型',
    afterSalesOrderNo:'3025 售后单号',
    afterSalesTime:'3026 售后时间',
    goodsAmount:'3027 货品金额',
    pendingEffect:'3028 待生效',
    effective:'3029 已生效',
    invalid:'3030 已失效',
    remarks:'3031 备注',
    logisticsInfo:'3032 物流信息',
    recipient:'3033 收件人',
    recipientPhone:'3034 收件人手机号',
    receivingAddress:'3035 收货地址',
    orderMethod:'3036 下单方式',
    jdAutoOrder:'3037 京东自动下单',
    manualOrder:'3038 手动下单',
    logisticsStatus:'3039 物流状态',
    packaged:'3040 已打包',
    shipped:'3041 运输中',
    signed:'3042 已签收',
    courierCompany:'3043 快递公司',
    trackingNumber:'3044 快递单号',
    cancel:'3045 取消',
    modify:'3046 修改',
    logisticsTracking:'3047 物流轨迹',
    customOrderInfo:'3048 客订信息',
    customOrderNo:'3049 客订单号',
    customOrderType:'3050 客订类型',
    deliveryStore:'3051 发货店铺',
    viewOrderDetails:'3052 查看详情',
    printReceipt:'3053 打印小票',
    continuePayment:'3054 继续支付',
    cancelOrder:'3055 取消订单',
    returnRefund:'3056 退货退款',
    fullRefund:'3057 整单退',
    openCollectMoney:'3058 收银台',
    hasReviewingNotOperate:'3059 有审批正在进行，无法操作按钮',
    confirmReturn:'3060 确认退货',
    cancelReturn:'3061 取消退货',
    sendToCustomer:'3062 寄件到客',
    outOfStockOrder:'3063 缺货客订',
    deleteHang:'3064 删除',
    sureHang:'3065 确认取单',
    hangDeleteContent:'3066 删除后无法恢复挂单记录，确定删除？',
    hangUseOtherThreeCoupon:'3067 使用了第三方优惠券，删除挂单会先尝试撤销优惠券，若撤销优惠券失败（超时效），需要顾客到第三方渠道操作退券。',
    hangDeleteTips:'3068 删除提示',
    getHangDataConfirm:'3069 确认提取该订单数据',
    getHangDataTip:'3070 取单提示',
    noOrderData:'3071 暂无订单详情数据',
    close:'3072 关闭',
    confirmClose:'3073 是否确认关闭',
    tips:'3074 提示',
    operationSuccess:'3075 操作成功',
    operationFailed:'3076 操作失败',
    confirmModifyOrder:'3077 是否确认修改订单，确认后本单将取消，将会把货品信息带到收银台',
    confirmReturnGoods:'3078 是否确认退货',
    confirmCancelReturn:'3079 是否取消退货',
    confirmCancelExpress:'3080 确认取消该快递单',
    expressCancelSuccess:'3081 快递单取消成功',
    orderMatchedShipped:'3082 已有客订匹配成功并发货，请在客订操作收货后妥善处理库存。',
    pleaseCloseCustomOrder:'3083 请先关闭客订。',
  },
  salsesOrder: {
    saleOrderNo:'3084 销售单号',
    placeholderEnterSaleOrderNo:'3085 请输入销售单号',
    goodsNoOrBarcode:'3086 货号/条码',
    placeholderEnterGoodsNoOrBarcode:'3087 请输入货号/条码',
    date:'3088 日期',
    to:'3089 至',
    startDate:'3090 开始日期',
    endDate:'3091 结束日期',
    orderNature:'3092 订单性质',
    placeholderSelect:'3093 请选择',
    performanceMethod:'3094 业绩方式',
    salesman:'3095 营业员',
    memberPhone:'3096 会员手机号',
    placeholderEnterMemberPhone:'3097 请输入会员手机号',
    documentSource:'3098 单据来源',
    sourceMobile:'3099 手机端',
    sourceClient:'3100 客户端',
    orderStatus:'3101 订单状态',
    statusCancelled:'已取消',
    statusPendingPayment:'待支付',
    statusCompleted:'已完成',
    statusInvalidated:'已作废',
    pendingConfirmation:'待确认',
    paymentMethod:'3107 支付方式',
    participatePromotion:'3108 参与促销',
    afterSalesOccurred:'3109 发生售后',
    approvalOccurred:'3110 发生审批',
    defectiveSalesOrder:'3111 次品销售单',
    asideYes:'3112 是',
    asideNo:'3113 否',
    asideCollapse:'3114 收起',
    asideExpand:'3115 展开',
    asideReset:'3116 重 置',
    asideConfirm:'3117 确 定',
    noDocumentRecords:'3118 未查询到单据记录',
    confirmTitle:'3119 提示',
    hangingOrderDeletedCouponRevoked:'3120 挂单删除成功，且优惠券已撤销。',
    hangingOrderDeletedCouponExpired:'3121 挂单删除成功，优惠券已过时效无法撤销需要到对应渠道操作退券。',
    operationSuccess:'3122 操作成功',
    // defectiveSalesOrder:'3123 次品销售单',
    approval:'3124 审批',
    withdrawn:'3125 已撤回',
    approved:'3126 已通过',
    rejected:'3127 已拒绝',
    pendingApproval:'3128 待审批',
    originalSalesOrder:'3129 原销售单',
    individualPerformance:'3130 个人业绩',
    teamPerformance:'3131 班组业绩',
    distribution:'3132 分销',
    totalQuantity:'3133 总件数',
    createTime:'3134 创建时间',
    teamMembers:'3135 班组人员',
    // salesman:'3136 营业员',
    afterSalesCount:'3137 产生售后次数',
    approvalCount:'3138 产生审批次数',
    amountReceivable:'3139 应收金额',
    amountReceived:'3140 实收金额',
    orderUnit:'件',
    copySuccess:'3142 复制成功！',
  },
  cancelOrder: {
    cancelTitle:'3143 取消订单',
    paySome:'3144 订单已完成部分支付',
    cancelSureTitle:'3145 确认取消？',
    notPayTips:'3146 订单未完成支付，确认取消？',
    cancelTextTips:'3147 订单使用了第三方优惠券，取消订单后系统会先尝试撤销优惠券，若撤销失败（超时效），需要顾客到第三方渠道操作退券。',
    cancelBtn:'3148 取 消',
    sureBtn:'3149 确 认',
    cancelSuccess:'3150 订单取消成功，且优惠券已撤销。',
    notRebackCoupon:'3151 订单取消成功，优惠券已过时效无法撤销需要到对应渠道操作退券。',
    tips:'3152 提示',
    canceTips:'3153 订单已取消',
  },
  changePrice: {
    title:'改价申请',
    submitter:'3172 提交人',
    selectPrompt:'3173 请选择',
    submitTime:'3174 提交时间',
    selectDateTime:'3175 选择日期时间',
    shopName:'3176 店铺名称',
    originalPrice:'3177 原价',
    newPrice:'3178 改后金额',
    changeAmount:'3179 变动金额',
    remark:'3180 备注',
    inputPrompt:'3181 请输入',
    priceChangedGoods:'3182 改价货品',
    addPrice:'增加{money}',
    miniPrice:'减少{money}',
    applicationInfo:'3185 申请单信息',
    cancel:'3186 取 消',
    confirm:'3187 确 认',
    operationInProgress:'3188 操作正在进行中，不能关闭',
    selectSubmitter:'3189 请选择申请人',
    fillApprovalRemark:'3190 请填写审批备注',
    submitSuccess:'3191 改价申请已提交',
  },
  returnGoods: {
    title:'3192 退货',
    priceTips:'货品的默认退货价会从原单卖价和现价之中取最低的价格；团购核销货品默认退货价由团购券的退券金额和优惠后实卖价计算得出。有特殊情况时可以改价审批',
    loading:'请稍后，全力加载中...',
    noGoodsImage:'暂无图片',
    barCodeCount:'{count} 件',
    goodsNoCount:'共 {count} 款',
    addBuy:'加购',
    gift:'赠品',
    activity:'促销',
    partialDiscount:'部分退折率',
    partialPriceType:'部分退取价',
    couponReturnTotal:'退券总价',
    infoTitle:'3204 退货信息',
    originalOrder:'3205 原销售单',
    salesman:'3206 营业员',
    publicOrder:'3207 公单',
    member:'3208 会员：',
    originalLatestAmount:'3209 原单最新金额',
    salesQuantity:'3210 销售件数',
    defaultReturnTotal:'3211 默认退货总价',
    returnQuantity:'3212 退货件数',
    refundAmount:'3213 退款金额',
    returnReason:'3214 请描述退货原因',
    pleaseInput:'3215 请输入',
    confirmReturn:'3216 确认退货',
    returnNotBigBuy:'3217 退货数量不能大于购买数量',
    returnNotMiniOne:'3218 退货数量不能小于1',
    returnOneBuy:'3219 退货数量不能为0且不能大于购买数量',
    confirmCancelPriceChange:'3220 确认要取消改价',
    tip:'3221 提示',
    selectGoodsTip:'3222 请选择要退货的货品',
    fillReasonTip:'3223 请填写退货原因',
    priceChangeExceedTip:'3224 以下货品改价金额超出了可改范围，请点击【确定】提交改价申请！',
    priceChangeReminder:'3225 改价提醒',
    confirmInfoTip:'3226 请确保退货信息无误，确定后将产生售后记录！',
    attention:'3227 注意事项：',
    publicOrderTip:'3228 公单销售会按原来的份额比例扣减业绩。',
    memberOrderTip:'3229 会员销售单的退货将减少会员积分。',
    thirdPartyCouponTip:'3230 第三方优惠券的购券金额已包含在货品退货价内，请勿重复处理第三方的退款申请，避免额外退款。',
    confirmReturnTitle:'3231 退货确认',
    allTitle:'3232 确定退货？',
    allCancel:'3233 取消',
    moneyUnit:'3234 元',
    allVipPayAndOther:'本单的支付方式为组合支付并且包含会员余额支付，只允许按原单卖价整单退货，需退现金',
    allHasCoupon:'含优惠券退券',
    allVipPay:'会员余额支付的',
    allBackVip:'将退回会员余额',
    allSure:'3239 确 定',
  },
  exchangeGoods: {
    loadingText:'3240 请稍后，全力加载中...',
    goodsImage:'3241 货品图片',
    noGoodsImage:'3242 暂无图片',
    goodsNo:'3243 货号',
    goodsBarCode:'3244 条码',
    goodsColor:'3245 颜色',
    goodsSize:'3246 尺码',
    goodsNumber:'3247 数量',
    goodsNoCount:'3248 件数',
    goodsType:'3249 类型',
    goodsInfo:'3250 货品信息',
    goodsAttr:'3251 颜色尺码',
    addBuy:'加购',
    gift:'赠品',
    activity:'促销',
    unitPrice:'3255 单价',
    amountPrice:'3256 合计金额',
    operation:'3257 操作',
    exchange:'3258 换货',
    noSelectedGoods:'3259 未选择换货货品',
    exchangeGoods:'3260 换货货品',
    promotionActivity:'3261 促销活动：',
    scanToAdd:'3262 请扫描或输入条码添加货品',
    confirm:'3263 确定',
    addManually:'3264 手动添加',
    replacementGoods:'3265 替换货品',
    delete:'3266 删除',
    reasonDesc:'3267 * 请描述换货原因：',
    pleaseInput:'3268 请输入',
    reselectGoods:'3269 重新选择换货货品',
    confirmExchange:'3270 确定换货',
    promotionEnd:'3271 该货品参与的促销活动已结束，不支持换货',
    tips:'3272 提示',
    gotIt:'3273 知道了',
    sameColorSizeError:'3274 不能换相同颜色尺码的货品',
    quantityExceedError:'3275 换货数量不能超过原货品数量',
    maxQuantityError:'3276 已达换货最大数量，不能再添加了',
    confirmDelete:'3277 是否删除该替换货品吗？',
    confirmReselect:'3278 确定要重新选择换货货品',
    noAddedGoods:'3279 您还没有添加换货货品',
    pleaseAddGoods:'3280 请添加要换货的货品',
    pleaseFillReason:'3281 请填写换货原因',
    promotionExchange:'3282 促销换货',
    colorCodeExchange:'3283 色码换货',
    chooseAttr:'3284 选择规格',
    pleaseInputGoodsNoCode:'3285 请输入货号/简码',
    searchGoods:'3286 搜 索',
    pleaseInputValueSearch:'3287 请输入货号或简码查询',
    attrStock:'3288 库存：{count}件',
    attCancel:'3289 取消',
    attrSure:'3290 确认',
    selectChangeColorSize:'3291 选择换货色码',
    selectColorSize:'3292 选择颜色尺码',
    attrMiniNumber:'3293 最小数量为1，不能再减了',
    goodsNoStock:'3294 当前货品库存不足，请选择其他货品',
    pleaseExchangeColorSize:'3295 请选择要换的颜色尺码',
    notChangeNormalAttr:'3296 不能换相同颜色和尺码的货品',
    currentMaxGoodsCount:'3297 当前最大可换货数量为{count}',
  },
  gridManage: {
    columnType:'3298 类型',
    columnGoodsInfo:'3299 货品信息',
    noGoodsImage:'暂无图片',
    badGoods:'次品',
    gave:'赠品',
    addBuy:'加购',
    activity:'促销',
    writeOff:'核销',
    goodsName:'3306 货品名称',
    goodsImages:'3307 货品图片',
    tagImages:'3308 吊牌图片',
    notUploadImg:'3309 未上传图片',
    goodsNo:'3310 货号',
    goodsBarCode:'3311 条码',
    columnAttr:'3312 颜色 / 尺码',
    goodsStock:'3313 可用库存',
    tagPrice:'3314 吊牌价',
    discount:'3315 折扣',
    number:'3316 数量',
    showOrRechoose:'3317 查看/重选货品',
    originalPrice:'3318 原单卖价',
    agoRealPrice:'3319 改前单价',
    realPrice:'3320 改后单价',
    beforeTotalPrice:'3321 改前总价',
    afterTotalPrice:'3322 改后总价',
    realPriceUnit:'3323 实卖价(单价)',
    alreadyChangePrice:'已改价',
    autoRepairPrice:'3325 自动补价',
    retailPrice:'3326 零售价',
    initRealPrice:'3327 原价',
    totalPrice:'3328 金额',
    columnAction:'3329 操作',
    rebackWriteOff:'3330 撤销核销',
    actionDelete:'3331 删除',
    rightshowStock:'3332 查看库存',
    rightDelect:'3333 删除',
    accountPrice:'3334 合计金额',
    currentSellPrice:'3335 当前零售价',
    fixedRetreatPrice:'3336 默认退货价',
    partReturnPrice:'3337 部分退折率',
    retreatPrice:'3338 退货价',
    retreatNumber:'3339 退货数量',
    totalRetreatPrice:'3340 退货金额',
    showGoods:'3341 查看货品',
    sellNumber:'3342 销售件数',
    suggestPrice:'3343 建议售价(单价)',
  },
  print: {
    printing:'3154 打印机正在打印',
    printFinishClick:'3155 打印完成后，点击下方完成打印按钮',
    finishPrint:'3156 完成打印',
    clickEnter:'3157 按回车可关闭',
    printTitle:'3158 打印小票',
    printInvoiceNo:'3159 单据编号',
    printCount:'3160 打印份数',
    printContent:'3161 打印内容',
    printAllLabel:'3162 总单',
    printOneFace:'3163 逐个打印包裹面单',
    printOneOut:'3164 逐个打印包裹外箱单',
    printDevice:'3165 打印机',
    pleaseSelectPrint:'3166 请选择打印机',
    printCancel:'3167 取消',
    printSure:'3168 确定打印',
    printSetTitle:'3169 打印设置',
    notPackagePickUp:'3170 {invoice}当前单据内没有包裹，请拣货打包产生包裹后再打印。',
  },
  auditDetail: {
    title:'3344 审批详情',
    loadingText:'3345 请稍后，全力加载中...',
    priceChangeApply:'3346 改价申请单',
    badGoodsApply:'3347 次品申请单',
    voidApply:'3348 作废申请单',
    submitter:'3349 提交人',
    submitTime:'3350 提交时间',
    shopName:'3351 店铺名称',
    originalPrice:'3352 原价',
    afterPrice:'3353 改后金额',
    priceChange:'3354 变动金额',
    remark:'3355 备注',
    couponInfo:'3356 优惠券信息',
    couponInfoSource:'3357 来源：',
    couponInfoType:'3358 优惠券类型：',
    validityPeriod:'3359 有效期：',
    to:'3360 至',
    changeGoodsList:'3361 单据内被改价的货品',
    badGoodsList:'3362 次品列表',
    voidList:'3363 作废货品列表',
    changeBefore:'3364 改前总价合计',
    changeAfter:'3365 改后总价合计',
  },
  promotion: {
    title:'3366 促销单详情',
    loadingText:'3367 请稍后，全力加载中...',
    activityInfo:'3368 促销单信息',
    activityName:'3369 促销名称',
    type:'3370 促销类型',
    activityNo:'3371 促销编号',
    effectiveType:'3372 有效类型',
    shortTerm:'3373 短期',
    longTerm:'3374 长期',
    discountAmount:'3375 减扣金额',
    realAmount:'3376 实付金额',
    totalAmount:'3377 合计金额',
    startTime:'3378 下单时间',
    goodsList:'3379 促销单货品列表',
    goodsImage:'3380 货品图片',
    noImage:'暂无图片',
    goodsName:'3382 货品名称',
    barCode:'3383 条码',
    goodsNo:'3384 货号',
    retailPrice:'3385 价格',
    attr:'3386 颜色 / 尺码',
  },
  sendToCustomer: {
    sendToCustomer: '3438 寄件到客',
    storeTypeFranchise: '3439 加盟',
    storeTypeDirect: '3440 直营',
    documentNo: '3441 单据号',
    sender: '3442 发出方',
    receiver: '3443 收货方',
    fillReceiverInfo: '3444 填写收货信息',
    inputMethod: '3445 录入方式',
    jdAutoOrder: '3446 京东自动下单',
    manualOrder: '3447 手动下单',
    estimatedWeight: '3448 预估重量：{weight}公斤',
    calcByProductWeight: '3449 根据货品资料克重计算',
    jdExpressCondition: '3450 当前重量<{weight}公斤，将下京东快递',
    logisticsNo: '3451 物流单号',
    scanOrInputLogisticsNo: '3452 请扫描或输入快递单号',
    expressCompany: '3453 快递公司',
    pleaseSelect: '3454 请选择',
    contactProductCenterForHelp: '3455 如有疑问请联系商品中心处理',
    cancel: '3456 取消',
    confirm: '3457 确认',
    receiverName: '3458 收件人姓名',
    phoneNumber: '3459 手机号',
    provinceCityArea: '3460 省市区',
    detailedAddress: '3461 详细地址',
    pleaseInput: '3462 请输入',
    autoParse: '3463 自动解析',
    changeReceiverInfo: '3464 修改收货信息',
    pleaseFillReceiverInfo: '3465 请填写收件方信息',
    pleaseFillLogisticsNo: '3466 请填写物流单号',
    pleaseSelectLogisticsCompany: '3467 请选择物流公司',
  },
  payment: {
    invoiceTitle: '3531 开发票',
    personalType: '3532 个人',
    enterpriseType: '3533 企业 / 组织',
    personalName: '3534 名称',
    idCardNo: '3535 身份证号',
    enterpriseName: '3536 企业名称',
    taxCode: '3537 税务代码',
    address: '3538 地址',
    inputPrompt: '3539 请输入',
    confirmBtn: '3540 确 定',
    nameRequiredPrompt: '3541 请填写名称',
    enterpriseNameRequiredPrompt: '3542 请填写企业名称',
    taxCodeRequiredPrompt: '3543 请填写税务代码',
    emailInputValidFormat: '请输入有效的电子邮箱格式',
    emailAddress: '3544 电子邮箱',
  },

  //登录
  login:{
    minimize:'1249 最小化',
    close:'1250 关闭',
    welcomeTitle:'1251 欢迎登录YY客户端',
    inputPhone:'1252 请输入用户手机号',
    inputPassword:'1253 请输入登录密码',
    rememberPassword:'1254 记住密码',
    loginBtn:'1255 登 录',
    scanCodeTip:'1256 请使用 APP 扫描下方二维码，点击 "确认授权" 即可登录',
    scanSuccessTip:'1257 扫码成功，请在手机上点击 “确认授权”',
    authorizing:'1258 授权中...',
    qrcodeExpired:'1259 二维码已过期',
    loginFail:'1260 登录失败',
    refreshQrcode:'1261 刷新二维码',
    qrcodeExpireTime:'1262 二维码超时时间：',
    multiCashierTip:'1263 已设置多个收银台，请选择当前收银设备对应的收银台',
    rememberSelection:'1264 在本机记住选择',
    confirmEnter:'1265 确认并进入',
    envSetting:'1266 客户端环境设置',
    inputPasswordTip:'1267 请输入密码',
    envSelect:'1268 环境选择：',
    prodEnv:'1269 正式环境',
    preEnv:'1270 公测环境',
    confirm:'1271 确定',
    validPhone:'1272 请输入有效手机号',
    inputPasswordRequired:'1273 请输入密码',
    correctDevPassword:'1274 请输入正确的开发者密码',
    envSwitchError:'1275 切换环境时异常',
    selectCashier:'1276 请选择一个收银台进入',
    switchLanguage:'3388 chuyển đổi ngôn ngữ',
    languageSwitchSuccess:'3392 切换语言成功！',
  },
  //首页
  home:{
    yyPartnerHome:'1277 YY首页',
    quit:'1278 退 出',
    navScanCode:'1279 扫码打卡',
    remoteHelp:'1280 远程协助',
    refreshPage:'1281 刷新页面',
    minimize:'1282 最小化',
    close:'1283 关闭',
    workbenchTitle:'1284 工作台',
    workbenchViewMore:'1285 查看更多',
    todoTitle:'1286 待办事项',
    todoAll:'1287 全部待办',
    todoTransferOrder:'1288 调出单',
    todoCustomerOrder:'1289 客订单',
    todoEnterOrderNo:'1290 请输入单据编号',
    todoSearch:'1291 搜 索',
    todoLastRefreshTime:'1292 上次刷新时间：',
    todoRefresh:'1293 刷新',
    tableType:'1294 类型',
    tableInvoiceNo:'1295 单据号',
    tableInvoiceDate:'1296 单据日期',
    tableRelatedStore:'1297 关联店仓',
    tableOverdueDays:'1298 逾期天数',
    enterpriseWindowTitle:'1299 企业窗口',
    newsReadCount:'1300 次阅读',
    performanceBoardTitle:'1301 业绩看板',
    performanceTodayDiff:'1302 今日业绩差额 (元)',
    performanceToday:'1303 今日',
    performanceTodayTarget:'1304 今日挑战目标',
    performanceTodayAchieve:'1305 实际完成',
    performanceMonthDiff:'1306 本月业绩差额 (元)',
    performanceMonth:'1307 本月',
    performanceMonthTarget:'1308 本月挑战目标',
    performanceMonthAchieve:'1309 实际完成',
    salesStaffTitle:'1310 营业员',
    salesStaffSerialNumber:'1311 序号',
    salesStaffName:'1312 营业员名称',
    salesStaffPerformance:'1313 营业员业绩 (元)',
    scanCodeTitle:'1314 扫码打卡',
    scanCodeCurrentDate:'1315 当前日期：',
    scanCodeCurrentTime:'1316 当前时间：',
    scanCodeScanToCheckIn:'1317 扫此码打卡，二维码间隔',
    secondRefs:'1318 秒刷新',
    scanCodeLoading:'1319 加载中...',
    weekMonday:'1320 周一',
    weekTuesday:'1321 周二',
    weekWednesday:'1322 周三',
    weekThursday:'1323 周四',
    weekFriday:'1324 周五',
    weekSaturday:'1325 周六',
    weekSunday:'1326 周日',
    messageLoadTimeout:'1327 加载时间过长，请关闭扫码打卡弹窗重新打开',
    messageConfirm:'1328 确定',
    messagePrompt:'1329 提示',
    confirmCloseApp:'1330 此操作将会关闭应用程序，是否确认关闭？',
    messageConfirm2:'1331 确定',
    confirmCancel:'1332 取消',
    newsDetailTitle:'1333 消息通知',
    updateCheckUpdate:'1334 （检查更新相关，无显式中文）',
    updateNewVersion:'1335 （版本更新相关，无显式中文）',
    searchPlaceholder:'3391 请输入功能名称搜索',
    searchGoods:'3529 搜 索',
    searchPlaceholder2:'3530 请输入标题/子标题/关键字/部门'
  },
  //公共组件
  components:{
    updateModuleCurrentBaseVersion:'1641 当前基座版本：V',
    updateModuleUpgradeToLatestVersion:'1642 升级到最新基座版本：',
    updateModuleReleaseTime:'1643 发布时间：',
    updateModuleDownloadNow:'1644 立即下载',
    updateModuleDownloadLater:'1645 暂不下载',
    updateModuleOpenFolder:'1646 打开文件夹',
    updateModuleDownloadCompleteMsg:'1647 新版本已下载完成，点击” 打开文件夹 “按钮安装新版本',
    settingCenter:'1648 设置中心',
    versionInfo:'1649 版本信息',
    voiceCall:'1650 语音通话',
    logFeedback:'1651 日志反馈',
    baseVersion:'1652 基座版本',
    appVersion:'1653 应用版本',
    checkUpdate:'1654 检查更新',
    connectionStatus:'1655 连接状态',
    normal:'1656 正常',
    disconnected:'1657 未连接',
    reconnect:'1658 重新连接',
    microphoneDevice:'1659 麦克风设备',
    openLogDir:'1660 打开日志所在目录',
    noUpdate:'1661 暂无更新',
    scanPayTitle:'1662 扫码收款',
    scanPayStepWaiting:'1663 等待到账',
    scanPayStepSuccess:'1664 到账成功',
    scanPayStepCanceled:'1665 已取消',
    scanPayStepDescriptionPrefix:'1666 第',
    scanPayStepDescriptionSuffix:'1667 笔收款：¥',
    scanPayTipScanCode:'1668 请扫描顾客的付款码',
    scanPayBtnConfirm:'1669 确 认',
    scanPayPaymentFailed:'1670 支付失败，请关闭或继续支付',
    scanPayBtnCancelPayment:'1671 取消支付',
    scanPayPaymentWaiting:'1672 提交成功，请等待金额到账',
    scanPayPaymentReminder:'1673 请注意提醒顾客输入支付密码，否则可能支付失败！！！请留意支付结果。',
    scanPayConfirmCloseAgain:'1674 本次支付未成功，确定要关闭',
    scanPayConfirmCloseNormal:'1675 关闭后可在销售记录中查看和再次发起支付',
    scanPayConfirmTitle:'1676 提示',
    returnRequestDrawerTitle:'1677 退货申请',
    returnRequestApplyInfoTitle:'1678 申请单信息',
    returnRequestFormSubmitUser:'1679 提交人',
    returnRequestFormPlaceholderSelect:'1680 请选择',
    returnRequestFormSubmitTime:'1681 提交时间',
    returnRequestFormShop:'1682 所在店铺',
    returnRequestFormSalesOrderNo:'1683 销售单号',
    returnRequestFormUseMemberContact:'1684 联系方式是否使用会员信息填入',
    returnRequestFormYes:'1685 是',
    returnRequestFormNo:'1686 否',
    returnRequestFormContactName:'1687 联系人姓名',
    returnRequestFormPlaceholderContactName:'1688 请输入顾客姓名',
    returnRequestFormPhone:'1689 手机号',
    returnRequestFormPlaceholderPhone:'1690 请输入手机号',
    returnRequestFormRemark:'1691 备注',
    returnRequestFormPlaceholderRemark:'1692 请输入备注',
    returnRequestGoodsInfoTitle:'1693 货品信息',
    returnRequestButtonsCancel:'1694 取 消',
    returnRequestButtonsConfirm:'1695 确 定',
    returnRequestMessagesErrorSelectSubmitUser:'1696 请选择申请人',
    returnRequestMessagesErrorEnterPhone:'1697 请输入联系人电话',
    returnRequestMessagesErrorEnterContactName:'1698 请输入联系人姓名',
    returnRequestMessagesSuccessApply:'1699 申请成功',
    returnRequestTableProductInfo:'1700 商品信息',
    returnRequestTableColorSize:'1701 颜色 / 尺码',
    returnRequestTableTagPrice:'1702 吊牌价',
    returnRequestTablePurchasePrice:'1703 购买价(单价)',
    returnRequestTableReturnPrice:'1704 退货价',
    returnRequestTableSalesQuantity:'1705 销售件数',
    returnRequestTableReturnReason:'1706 退货原因',
    returnRequestTableReturnQuantity:'1707 退货件数',
    returnRequestTablePromotion:'1708 促销',
    returnRequestTableNoImage:'暂无图片',
    returnRequestTableItemNo:'1710 货号：',
    returnRequestTableBarcode:'1711 条码：',
    settlementTitle:'结算',
    settlementSalesman:'1713 营业员：',
    settlementMember:'1714 会员：',
    settlementGoodsTotalPrice:'1715 货品总价',
    settlementPromotionDiscount:'1716 促销活动优惠',
    settlementReduce:'减',
    settlementCouponWriteOff:'1718 优惠券核销',
    settlementFinalTotalPrice:'1719 最终总价',
    settlementParticipatedPromotions:'1720 参与的促销活动',
    settlementCollapse:'1721 收起',
    settlementExpand:'1722 展开',
    settlementPiece:'{count} 件',
    settlementGift:'1724 赠品',
    settlementAdditionalPurchase:'加购',
    settlementPromotion:'促销',
    settlementTotal:'1727 共',
    settlementItem:'共 {count} 款',
    settlementOriginalPrice:'1729 原价',
    settlementDiscount:'1730 优惠',
    settlementAfterDiscount:'1731 优惠后',
    settlementUsedCoupons:'1732 已使用的优惠券核销',
    settlementTagPrice:'1733 吊牌价',
    settlementOriginal:'1734 原价',
    settlementTagDiscount:'1735 吊牌优惠',
    settlementNeedMakeUp:'1736 需补差：',
    settlementNoRefund:'1737 差额不退',
    settlementNoPaymentMethod:'1738 当前店铺未关联支付方式',
    settlementOrderAmount:'1739 本单金额：',
    settlementAlreadyPaid:'1740 已经支付：',
    settlementNeedToReceive:'1741 还需收款',
    settlementAmountReceived:'1742 实收金额',
    settlementConfirmCollection:'1743 确认收款',
    settlementChangeTool:'1744 找零小工具',
    settlementReceivedAmount:'1745 实收金额',
    settlementChangeAmount:'1746 找零金额',
    settlementScanCouponCode:'1747 请扫描顾客优惠券码，支持手动输入',
    settlementSwitchToEnglish:'1748 扫码时请将输入法切换成英文',
    settlementTiktokVerificationNote:'1749 该扫码仅用于查询顾客券码是否有效！确认用券请使用抖音来客 APP 完成实际核销。',
    settlementSource:'1750 来源：',
    settlementDouyin:'1751 抖音',
    settlementDelete:'1752 删除',
    settlementValidityPeriod:'1753 有效期：',
    settlementSplitDetails:'1754 拆分明细',
    settlementPaymentCount:'1755 收款次数',
    settlementPaymentAmount:'1756 支付金额',
    settlementOperation:'1757 操作',
    settlementTime:'1758 次收款',
    settlementAvailableSplitAmount:'1759 可拆分金额：',
    settlementAdd:'1760 新增',
    settlementSelected:'1761 已选择',
    settlementSplit:'1762 拆分',
    settlementAvailableBalance:'1763 可用余额：',
    settlementEnterCorrectAmount:'1764 请填写正确的金额',
    settlementInsufficientBalance:'1765 余额不足，当前会员余额只有',
    settlementFillAmountFirst:'1767 请先填写金额',
    settlementEnterValidAmount:'1768 请填写大于 0 的有效金额',
    settlementChoosePaymentMethod:'1769 请选择至少一种收款方式',
    settlementCheckAmount:'1770 请检查金额是否正确',
    settlementCheckNegativeAmount:'1771 请检查金额是否正确，请取消勾选金额小于 0 元的收款方式',
    settlementScanTiktokCoupon:'1772 请扫描顾客优惠券码添加优惠券',
    settlementCheckOrderStatus:'1773 请到销售记录查看订单状态，若没有该订单请重新打单。',
    settlementPrompt:'1774 提示',
    paymentSuccessful:'1775 买单成功！',
    settlementStepDescriptionPrefix:'1776 第',
    orderCardDefectiveSalesOrder:'1777 次品销售单',
    orderCardApproval:'1778 审批',
    orderCardReviewStateWithdrawn:'1779 已撤回',
    orderCardReviewStateApproved:'1780 已通过',
    orderCardReviewStateRejected:'1781 已拒绝',
    orderCardReviewStatePending:'1782 待审批',
    orderCardSalesOrderNo:'1783 销售单号：',
    orderCardDocumentSource:'1784 单据来源：',
    orderCardSourceMobile:'1785 手机端',
    orderCardSourceClient:'1786 客户端',
    orderCardOrderNature:'1787 订单性质：',
    orderCardOriginalSalesOrder:'1788 原销售单：',
    orderCardPerformanceMethod:'1789 业绩方式：',
    orderCardBrokeragePersonal:'1790 个人业绩',
    orderCardBrokerageTeam:'1791 班组业绩',
    orderCardBrokerageDistribution:'1792 分销',
    orderCardTotalPieces:'1793 总件数：',
    orderCardCreateTime:'1794 创建时间：',
    orderCardTeamMembers:'1795 班组人员',
    orderCardSalesman:'1796 营业员',
    orderCardAfterSalesCount:'1797 产生售后次数：',
    orderCardReviewCount:'1798 产生审批次数：',
    orderCardReceivableAmount:'1799 应收金额：',
    orderCardActualReceivedAmount:'1800 实收金额：',
    orderCardCopySuccess:'1801 复制成功！',
    maskLayerPageLocked:'1802 当前页面已锁定',
    maskLayerUnlockTip:'1803 输入正确密码后可成功解锁',
    maskLayerEnterPassword:'1804 请输入密码',
    maskLayerConfirm:'1805 确 定',
    maskLayerClickToUnlock:'1806 点击解锁',
    maskLayerEnterUnlockPwd:'1807 请输入解锁密码',
    maskLayerCorrectUnlockPwd:'1808 请输入正确的解锁密码',
    newsDetailTitleSuffix:'1809 -- 详情',
    commonConfirmFirst:'1810 确 定',
    flowStepsTitle:'1811 审批流程',
    flowStepsStepTypeApprove:'1812 审批',
    flowStepsStepTypeExecuteOnly:'1813 仅执行',
    flowStepsStepTypeCcOnly:'1814 仅抄送',
    flowStepsReviewTypeOrSign:'1815 或签',
    flowStepsReviewTypeAllSign:'1816 全签',
    flowStepsReviewUsersCount:'1817 人审批',
    flowApprovalProcess:'1818 审批流程',
    flowStateUnreviewed:'1819 未审核',
    flowStateApproved:'1820 审核通过',
    flowStateRejected:'1821 审核拒绝',
    flowReviewTypeAllSign:'1822 全签',
    flowReviewTypeOrSign:'1823 或签',
    flowUserStateWithdrawn:'1824 已撤回',
    flowUserStateUntreated:'1825 未处理',
    flowUserStateAgreed:'1826 已同意',
    flowUserStateRejected:'1827 已拒绝',
    flowUserStateExecuted:'1828 已执行',
    dragErrorMissingName:'1829 缺少配置关联名 name',
    dragErrorMissingProp:'1830 缺少配置关联属性 name',
    dialogOrderNote:'1831 整单备注：',
    dialogShowPendingAndPaid:'1832 只显示待支付和已支付',
    dialogWithinMinutes:'1833 分钟内的订单',
    checkAudioDialogTitle:'1834 提示',
    checkAudioDialogNoMicPermissionMsg:'1835 系统检测到未开启麦克风权限，请前往系统设置打开麦克风！',
    checkAudioDialogViewWin10Guide:'1836 查看 win10 系统如何启动？',
    checkAudioDialogViewWin11Guide:'1837 查看 win11 系统如何启动？',
    checkAudioDialogContactItHint:'1838 不知道如何查看？请联系 IT 专员',
    checkAudioDialogRefreshAfterSetup:'1839 我已设置，刷新系统',
    checkAudioDialogHowToEnableTitle:'1840 如何开启麦克风',
    commonConfirmSecond:'1841 确 定',
    consumingTime:'1842 耗时：',
    statusIssued:'1843 已下发',
    statusShipped:'1844 已出货',
    statusLogisticsToStore:'1845 物流到店',
    statusLogisticsToWarehouse:'1846 物流到仓',
    statusStored:'1847 已入库',
    selectUserPlaceholder:'1848 请选择用户',
    selectAreaPlaceholder:'1849 请选择区域',
    buttonReset:'1850 重置',
    buttonQuery:'1851 查询',
    // buttonAddStoreInfo:'1852 新增店铺资料',
    // buttonAddAccountInfo:'1853 新增账户信息',
    // buttonAddSalesPromotion:'1854 新增促销',
    filterCollapse:'1855 收起',
    filterExpand:'1856 展开',
    buttonAddStoreInfo:'1857 新增店铺资料',
    buttonAddAccountInfo:'1858 新增账户信息',
    buttonAddSalesPromotion:'1859 新增促销',
    supplierNameLabel:'1860 供应商名称：',
    supplierCodeLabel:'1861 编号：',
    supplierFullNameLabel:'1862 供应商全称：',
    supplierDefaultType:'1863 工服物料',
    supplierType1:'1864 加工',
    supplierType2:'1865 成品',
    supplierType3:'1866 面料',
    supplierType4:'1867 辅料',
    supplierType5:'1868 吊牌',
    supplierType6:'1869 行政物料',
    supplierType7:'1870 广告物料',
    entrepotNameLabel:'1871 名称：',
    entrepotCodeLabel:'1872 编号：',
    entrepotAddressLabel:'1873 地址：',
    searchFormFilter:'1874 筛选',
    searchFormCollapse:'1875 点击收起',
    searchFormStartTime:'1876 开始时间',
    searchFormEndTime:'1877 结束时间',
    searchFormConfirm:'1878 确定',
    searchFormReset:'1879 重置',
    searchFormPleaseSelect:'1880 请选择',
    searchFormPleaseInput:'1881 请输入',
    searchFormTo:'1882 至',
    invoiceFormInvoiceNo:'1883 单据编号：',
    printCopies:'1884 打印份数：',
    printContent:'1885 <i>*</i>打印内容：',
    printTotalOrder:'1886 总单',
    printPackageWaybillOneByOne:'1887 逐个打印包裹面单',
    printPackageOuterBillOneByOne:'1888 逐个打印包裹外箱单',
    printPrinter:'1889 <i>*</i>打印机：',
    commonSelectPrinter:'1890 请选择打印机',
    commonCancel:'1891 取 消',
    printConfirmPrint:'1892 确定打印',
    printPrinting:'1893 打印机正在打印',
    printSetting:'1894 打印设置',
    printErrorNoPackage:'1895 当前单据内没有包裹，请拣货打包产生包裹后再打印。',
    printDialogPackageNo:'1896 包裹号：',
    printDialogPrintCopies:'1897 打印份数：',
    printDialogPrintContent:'1898 打印内容：',
    printDialogPackageDetail:'1899 包裹明细单',
    printDialogPackageOuter:'1900 包裹外箱单',
    printDialogPrinter:'1901 打印机：',
    printDialogSelectPrinter:'1902 请选择打印机',
    cancel:'1903 取 消',
    printDialogConfirmPrint:'1904 确定打印',
    printDialogPrinting:'1905 打印机正在打印',
    printDialogPrintSetting:'1906 打印设置',
    supplierName:'1907 供应商名称：',
    supplierCode:'1908 编号：',
    supplierFullName:'1909 供应商全称：',
    supplierTypeProcessing:'1910 加工',
    supplierTypeFinishedProduct:'1911 成品',
    supplierTypeFabric:'1912 面料',
    supplierTypeAccessory:'1913 辅料',
    supplierTypeHangtag:'1914 吊牌',
    supplierTypeAdministrativeMaterial:'1915 行政物料',
    supplierTypeAdvertisingMaterial:'1916 广告物料',
    supplierTypeWorkwearMaterial:'1917 工服物料',
    optionEntrepotName:'1918 名称：',
    optionEntrepotCode:'1919 编号：',
    optionEntrepotAddress:'1920 地址：',
    messageDialogBatchResultTitle:'1921 批量操作结果',
    messageDialogBatch:'1922 批量',
    messageDialogOperationResult:'1923 操作结果',
    messageDialogSuccess:'1924 成功',
    messageDialogFailure:'1925 失败',
    messageDialogTotal:'1926 总共',
    messageDialogOrderNumber:'1927 单号',
    messageDialogResult:'1928 结果',
    messageDialogReason:'1929 原因',
    messageDialogRemark:'1930 备注',
    storeDialogTitle:'1931 选择店铺',
    storeDialogFilterCondition:'1932 筛选条件',
    storeDialogFormMarketingName:'1933 店铺名称',
    storeDialogFormMarketingNamePlaceholder:'1934 请填写店名，多个以空格分隔',
    storeDialogFormCode:'1935 店铺编号',
    storeDialogFormCodePlaceholder:'1936 请填写编号，多个以空格分隔',
    storeDialogFormOperatingState:'1937 营业状态',
    storeDialogOperatingStateNormal:'1938 正常营业',
    storeDialogOperatingStateTemporary:'1939 临时营业',
    storeDialogOperatingStateClosed:'1940 关店停业',
    storeDialogOperatingStateNotOpened:'1941 未开业',
    storeDialogButtonsReset:'1942 重置',
    storeDialogButtonsSearch:'1943 查询',
    storeDialogUnselectedStore:'1944 未选择店铺',
    storeDialogTotalFormat:'1945 共{count}',
    storeDialogTableCode:'1946 编号',
    storeDialogTableName:'1947 店铺名称',
    storeDialogModeMultiple:'1948 多选模式',
    storeDialogModeSingle:'1949 单选模式',
    storeDialogButtonsSelectAll:'1950 全选',
    storeDialogButtonsMoveRight:'1951 右移',
    storeDialogButtonsMoveLeft:'1952 左移',
    storeDialogButtonsDeselectAll:'1953 全选',
    storeDialogSelectedStore:'1954 已添加店铺',
    storeDialogButtonsCancel:'1955 取 消',
    storeDialogButtonsConfirm:'1956 确 定',
    storeDialogErrorsSingleSelectLimit:'1957 单选模式，仅能选择一条数据',
    storeDialogErrorsSelectFirst:'1958 请先选择数据',
    goodsNoDialogTitle:'1959 选择货号',
    goodsNoDialogFilterCondition:'1960 筛选条件',
    goodsNoDialogFormGoodsName:'1961 货品名称',
    goodsNoDialogFormPlaceholderGoodsName:'1962 请填写货品名称，多个以空格分隔',
    goodsNoDialogFormGoodsNo:'1963 货号',
    goodsNoDialogFormPlaceholderGoodsNo:'1964 请填写货号，多个以空格分隔',
    goodsNoDialogFormYear:'1965 年份',
    goodsNoDialogFormQuarter:'1966 季节',
    goodsNoDialogFormStyleCategory:'1967 款式分类',
    goodsNoDialogFormStyleType:'1968 风格分类',
    goodsNoDialogButtonsReset:'1969 重置',
    goodsNoDialogButtonsSearch:'1970 查询',
    goodsNoDialogUnselectedTitle:'1971 未选择货号',
    goodsNoDialogUnselectedTotal:'1972 共',
    goodsNoDialogTableColumnsGoodsNo:'1973 货号',
    goodsNoDialogTableColumnsGoodsName:'1974 货品名称',
    goodsNoDialogButtonsSelectAllRight:'1975 全选',
    goodsNoDialogButtonsMoveRight:'1976 右移',
    goodsNoDialogButtonsMoveLeft:'1977 左移',
    goodsNoDialogButtonsSelectAllLeft:'1978 全选',
    goodsNoDialogSelectedTitle:'1979 已添加货号',
    goodsNoDialogSelectedTotal:'1980 共',
    goodsNoDialogFooterCancel:'1981 取 消',
    goodsNoDialogFooterConfirm:'1982 确 定',
    goodsNoDialogErrorsSingleSelectLimit:'1983 单选模式，仅能选择一条数据',
    goodsNoDialogErrorsSelectFirst:'1984 请先选择数据',
    warehouseDialogTitle:'1985 选择仓库',
    warehouseDialogFilterCondition:'1986 筛选条件',
    warehouseDialogFormWarehouseName:'1987 仓库名称',
    warehouseDialogFormPlaceholderWarehouseName:'1988 请填写仓库名称，多个以空格分隔',
    warehouseDialogFormWarehouseCode:'1989 仓库编号',
    warehouseDialogFormPlaceholderWarehouseCode:'1990 请填写仓库编号，多个以空格分隔',
    warehouseDialogFormType:'1991 类型',
    warehouseDialogFormState:'1992 状态',
    warehouseDialogFormEnableStatus:'1993 启用状态',
    warehouseDialogButtonsReset:'1994 重置',
    warehouseDialogButtonsSearch:'1995 查询',
    warehouseDialogUnselectedWarehouse:'1996 未选择仓库',
    warehouseDialogTotalPrefix:'1997 共',
    warehouseDialogTableColumnsCode:'1998 编号',
    warehouseDialogTableColumnsName:'1999 名称',
    warehouseDialogTableColumnsStatus:'2000 状态',
    warehouseDialogStatusEnabled:'2001 启用',
    warehouseDialogStatusDisabled:'2002 禁用',
    warehouseDialogModeMultiple:'2003 多选模式',
    warehouseDialogModeSingle:'2004 单选模式',
    warehouseDialogButtonsCheckAll:'2005 全选',
    warehouseDialogButtonsShiftRight:'2006 右移',
    warehouseDialogButtonsShiftLeft:'2007 左移',
    warehouseDialogButtonsRemoveAll:'2008 清空',
    warehouseDialogSelectedWarehouse:'2009 已添加仓库',
    warehouseDialogButtonsCancel:'2010 取 消',
    warehouseDialogButtonsConfirm:'2011 确 定',
    warehouseDialogMessagesSingleSelectLimit:'2012 单选模式，仅能选择一条数据',
    warehouseDialogMessagesSelectFirst:'2013 请先选择数据',
    warehouseDialogTypeListPhysical:'2014 实体仓',
    warehouseDialogTypeListWorkwear:'2015 工服仓',
    warehouseDialogTypeListAdministrative:'2016 行政物料仓',
    warehouseDialogTypeListCloud:'2017 云仓',
    warehouseDialogTypeListVirtual:'2018 虚拟仓',
    warehouseDialogStateListAll:'2019 全部',
    warehouseDialogStateListNormal:'2020 正常',
    warehouseDialogStateListDeleted:'2021 删除',
    warehouseDialogEnableListYes:'2022 是',
    warehouseDialogEnableListNo:'2023 否',
    basicSelectorNoData:'2024 无匹配选项',
    basicSelectorLoading:'2025 加载中...',
    basicSelectorNoMore:'2026 没有更多',
    stockTopMenuCashierLabel:'2027 收银台：',
    stockTopMenuLockWithF2:'2028 锁定 (F2)',
    stockTopMenuRefreshPage:'2029 刷新页面',
    stockTopMenuMinimize:'2030 最小化',
    stockTopMenuClose:'2031 关闭',
    stockTopMenuPrompt:'2032 提示',
    stockTopMenuCloseWindowConfirm:'2033 此操作将会关闭当前窗口，是否确认关闭？',
    stockTopMenuConfirm:'2034 确定',
    stockTopMenuCancel:'2035 取消',
    stockTopMenuUserCancelLog:'2036 用户点击取消',
    stockTopMenuTranslante:'3390 打开翻译',
    zDialogRefresh: '3393 刷新',
    zDialogMinimize: '3394 缩小',
    zDialogMaximize: '3395 放大',
    zDialogClose: '3396 关闭',
    zDialogTips: '3397 提示',
    zDialogConfirm: '3398 确定',
    zDialogCancel: '3399 取消',
    zDialogConfirmCloseMessage: '3400 确定关闭?',
    zDialogConfirmExitMessage: '3401 本次提交的内容将不会被保存，是否退出 ?',
    sizeGroupTableSizeGroup: '3409 尺码组',
    sizeGroupTableSelectDate: '3410 选择日期',
    sizeGroupTableOperation: '3411 操作',
    sizeGroupTableTotal: '3412 合计',
    sizeGroupTableTotalAmount: '3413 总款数',
    sizeGroupTableUnitPiece: '个',
    sizeGroupTableTotalPieces: '3414 总件数',
    sizeGroupTableUnitItem: '件',
    sizeGroupTableTotalPrice: '3415 总价',
    sizeGroupTableTransferTotalPieces: '3416 调拨总件数',
    sizeGroupTableReturnWarehouseTotalPieces: '3417 退仓总件数',
    sizeGroupTableDistributionTotalPieces: '3418 铺货总件数',
    sizeGroupTablePurchaseTotalPrice: '3419 采购总价',
    sizeGroupTableTagTotalPrice: '3420 吊牌总价',
    sizeGroupTableTransferTotalPrice: '3421 调拨总价',
    sizeGroupTableReturnWarehouseTotalPrice: '3422 退仓总价',
    sizeGroupTableDistributionTotalPrice: '3423 铺货总价',
    sizeGroupTableRetailTotalPrice: '3424 零售总价',
    sizeGroupTableReceived: '3425 已收',
    sizeGroupTableNotReceived: '3426 未收',
    sizeGroupTableShipmentDifferenceTotal: '3427 出货差异总数',
    sizeGroupTableStorageDifferenceTotal: '3428 入库差异总数',
    sizeGroupTableOutboundDifferenceTotal: '3429 出库差异总数',
    sizeGroupTableAdjustTotalPieces: '3430 调整总件数',
    sizeGroupTableTakenQuantity: '3431 已提数',
    sizeGroupTableNotTakenQuantity: '3432 未提数',
    sizeGroupTableStorageQuantity: '3433 入库数',
    sizeGroupTableReturnSupplierQuantity: '3434 退供数',
    sizeGroupTableReturnSupplierAmount: '3435 退供金额',
    sizeGroupTablePicked: '3436 已拣',
    sizeGroupTableNotPicked: '3437 未拣',
  },
  //时段目标
  timeTargetFollow:{
    curPosition:'2037 时段目标跟进',
    elementLoadingText:'2038 请稍后，全力加载中...',
    tipsAnalysisFocusTime:'2039 分析每天业绩的重点时段',
    tipsFocusYesterdayGap:'2040 关注与昨天同时段的差距',
    tipsStrengthenTargetFocus:'2041 不断加强自己对目标的关注',
    tipRowDingTalkNotice:'2042 每天定时截图发送至钉钉 <店铺钉钉群>，延时不得超过 30 分钟',
    dateRowLabel:'2043 日期',
    datePickerPlaceholder:'2044 选择日期',
    buttonSave:'2045 保存',
    noDataText:'2046 未查询到业绩数据',
    messageCannotModifyExceptToday:'2047 只能修改当天的业绩',
    messageModifyBeforeSave:'2048 请修改业绩后再保存',
    messageOperationSuccess:'2049 操作成功',
  },
  //补打标签
  relabel:{
    title:'2050 补打标签',
    searchSpuCode:'2051 货号 / 简码',
    searchPlaceholderSpu:'2052 请输入货号或简码',
    searchGoodsName:'2053 货品名称',
    searchPlaceholderTitle:'2054 请输入货品名称',
    btnReset:'2055 重置',
    btnSearch:'2056 搜索',
    tableSpu:'2057 货号',
    tableGoodsCode:'2058 简码',
    tableTitle:'2059 货品名称',
    tableColor:'2060 颜色',
    previewGoodsImage:'2061 货品图片',
    previewPrintPreview:'2062 打印预览',
    previewSelectSize:'2063 请选择货品尺码',
    btnPrintTag:'2064 打印标签',
    confirmCloseTitle:'2065 提示',
    confirmCloseMessage:'2066 此操作将会关闭当前窗口，是否确认关闭？',
    confirmConfirm:'2067 确定',
    confirmCancel:'2068 取消',
    errorSelectSize:'2069 请选择需要打印的尺码',
  },
  //会员相关
  vipModule:{
    promotionDetailTitle:'2070 促销详情',
    promotionInfoTitle:'2071 促销单信息',
    promotionNameLabel:'2072 促销名称：',
    promotionTypeLabel:'2073 促销类型：',
    promotionNoLabel:'2074 促销编号：',
    promotionEffectiveTypeLabel:'2075 有效类型：',
    promotionShortTerm:'2076 短期',
    promotionLongTerm:'2077 长期',
    promotionDeductAmountLabel:'2078 减扣金额：',
    promotionActualPayLabel:'2079 实付金额：',
    promotionTotalAmountLabel:'2080 合计金额：',
    promotionOrderTimeLabel:'2081 下单时间：',
    promotionGoodsListTitle:'2082 促销单货品列表',
    promotionGoodsImageLabel:'2083 货品图片',
    promotionNoImageText:'2084 暂无图片',
    promotionGoodsNameLabel:'2085 货品名称',
    promotionBarCodeLabel:'2086 条码',
    promotionGoodsNoLabel:'2087 货号',
    promotionPriceLabel:'2088 价格',
    promotionAttrLabel:'2089 颜色 / 尺码',
    couponDetailTitle:'2090 优惠券详情',
    couponInfoTitle:'2091 优惠券信息',
    couponTypeLabel:'2092 优惠券类型：',
    couponSourceLabel:'2093 优惠券来源：',
    couponDiscountAmountLabel:'2094 优惠金额：',
    couponNameLabel:'2095 优惠券名称：',
    couponVerifyTimeLabel:'2096 核销时间：',
    couponOrderMinCountLabel:'2097 整单最低件数：',
    couponTagPriceDenominationLabel:'2098 吊牌价面额：',
    couponDescriptionLabel:'2099 优惠券说明：',
    couponGoodsTitle:'2100 优惠券货品',
    couponGoodsNoLabel:'2101 货号',
    couponGoodsNameLabel:'2102 货品名称',
    couponQuantityLabel:'2103 数量',
    couponTagPriceLabel:'2104 吊牌价',
    couponSingleDiscountLabel:'2105 单件优惠抵扣',
    couponActualPriceLabel:'2106 实卖价',
    couponColorSizeLabel:'2107 颜色 / 尺码',
    couponGiftsTitle:'2108 赠品',
    couponNoGoodsImageText:'2109 该货号没有货品图片',
    createVipDialogTitle:'2110 创建会员',
    createVipNickNameLabel:'2111 会员昵称',
    createVipNickNamePlaceholder:'2112 请输入会员昵称',
    createVipNickNameRequired:'2113 请填写会员名称',
    createVipRealNameLabel:'2114 真实姓名',
    createVipRealNamePlaceholder:'2115 请输入真实姓名',
    createVipPhoneLabel:'2116 手机号',
    createVipPhonePlaceholder:'2117 请输入手机号',
    createVipPhoneRequired:'2118 请填写手机号',
    createVipSexLabel:'2119 性别',
    createVipSexMale:'2120 男',
    createVipSexFemale:'2121 女',
    createVipSexRequired:'2122 请选择性别',
    createVipDeptIdLabel:'2123 绑定店铺',
    createVipDeptIdPlaceholder:'2124 请选择性别',
    createVipAssistantUserIdLabel:'2125 发卡导购',
    createVipAssistantUserIdPlaceholder:'2126 请选择发卡导购',
    createVipBirthdayLabel:'2127 出生年月',
    createVipBirthdayPlaceholder:'2128 请选择出生年月日',
    createVipBirthdayCalendarTypeLabel:'2129 生日历法类型',
    createVipBirthdayCalendarSolar:'2130 公历',
    createVipBirthdayCalendarLunar:'2131 农历',
    createVipIdNumLabel:'2132 身份证号',
    createVipIdNumPlaceholder:'2133 请输入身份证号',
    createVipCoatSizeLabel:'2134 上衣尺寸',
    createVipCoatSizePlaceholder:'2135 请输入上衣尺寸',
    createVipWaistlineLabel:'2136 腰围尺寸',
    createVipWaistlinePlaceholder:'2137 请输入腰围尺寸',
    createVipHeightLabel:'2138 身高 (cm)',
    createVipHeightPlaceholder:'2139 请输入身高',
    createVipWeightLabel:'2140 体重 (kg)',
    createVipWeightPlaceholder:'2141 请输入体重',
    createVipShoeSizeLabel:'2142 鞋码',
    createVipShoeSizePlaceholder:'2143 请输入鞋码',
    createVipCancelBtn:'2144 取 消',
    createVipConfirmBtn:'2145 确 认',
    createVipInvalidPhoneMsg:'2146 请填写手机号',
    createVipCreateSuccessMsg:'2147 会员创建成功',
    integralTitle:'2148 积分兑换',
    integralGiftNameGoodsNoLabel:'2149 礼品名称 / 货号',
    integralSearchPlaceholder:'2150 扫描吊牌或输入货号查询',
    integralQueryBtn:'2151 查询',
    integralSelectEnlargeTip:'2152 点击选中积分礼品后可点击右侧图片放大查看',
    integralSingleLimitTip:'2153 单次限兑换 {num} 个',
    integralCommonLabel:'积分',
    integralNotInExchangeTimeTip:'2155 POS 端未在兑换时间内',
    integralNoDataText:'2156 暂无数据',
    integralPleaseSelectText:'2157 请选择',
    integralMemberScanCodePlaceholder:'2158 请扫描会员码',
    integralMemberPhoneOrCodePlaceholder:'2159 请输入手机号或扫描会员码',
    integralMemberPhonePlaceholder:'2160 请输入会员手机号',
    integralConfirmBtn:'2161 确定',
    integralMemberShowCodeTip:'2162 可在微信公众号打开 [会员中心] 出示会员码',
    integralMemberNameLabel:'2163 会员名称',
    integralMemberPhoneLabel:'2164 手机号',
    integralMemberBalanceLabel:'2165 余额',
    integralReselectBtn:'2166 重选',
    integralGoodsNameLabel:'2167 货品名称：',
    integralSizeLabel:'2168 尺码：',
    integralColorLabel:'2169 颜色：',
    integralExchangeQuantityLabel:'2170 兑换数量：',
    integralStockLabel:'2171 库存：',
    integralSelectGiftFirstTip:'2172 请先选择积分礼品',
    integralTotalLabel:'2173 合计：',
    integralRemainingAfterExchangeLabel:'2174 兑换后剩余：',
    integralConfirmExchangeBtn:'2175 确认兑换',
    integralDialogTipTitle:'2176 提示',
    integralMemberRestrictedMsg:'2177 抱歉，该会员资格暂时受到限制，无法使用，我们建议您联系 IT 了解具体情况并解决问题。',
    integralOkBtn:'2178 确 定',
    integralPleaseScanMemberError:'2179 请先扫描会员码',
    integralPleaseSelectGiftError:'2180 请先选择礼品',
    integralSingleLimitError:'2181 当前礼品单次限兑换 {num} 个',
    integralConfirmExchangeMsg:'2182 确认兑换礼品？',
    integralExchangeSuccessMsg:'2183 兑换成功',
    integralPositiveIntegerError:'2184 请填写大于或等于 1 的整数',
    integralMinQuantityError:'2185 最小数量为 1，不能再减了',
    integralExchangeDateTip:'2186 当前选中礼品兑换日期为 {start} ~ {end}',
    integralPageSize100Label:'2187 100 条 / 页',
    integralPageSize200Label:'2188 200 条 / 页',
    integralPageSize300Label:'2189 300 条 / 页',
    integralPageSize400Label:'2190 400 条 / 页',
    integralPageSize500Label:'2191 500 条 / 页',
    memberRechargeTitle:'2192 会员余额充值',
    chooseAssistantText:'2193 选择营业员',
    salesmanLabel:'2194 营业员：',
    chooseMemberText:'2195 请选择会员',
    memberNameLabel:'2196 会员名称：',
    phoneLabel:'2197 手机号：',
    memberCardNumberLabel:'2198 会员卡号：',
    availableBalanceLabel:'2199 可用余额',
    occupiedBalanceLabel:'2200 占用余额',
    switchMemberBtn:'2201 切换会员',
    noRechargeTemplateText:'2202 店铺还未设置充值模板',
    giveText:'2203 送',
    pointsLabel:'2204 积分',
    noPaymentMethodText:'2205 店铺还未关联支付方式',
    selectedLabel:'2206 已选择',
    splitBtn:'2207 拆分',
    yuanUnit:'2208 元',
    changeToolTitle:'2209 找零小工具',
    receivedAmountLabel:'2210 实收金额',
    changeAmountLabel:'2211 找零金额',
    splitDetailsTitle:'2212 拆分明细',
    paymentTimesLabel:'2213 收款次数',
    paymentAmountLabel:'2214 支付金额',
    operationLabel:'2215 操作',
    paymentTimesPrefix:'2216 第',
    paymentTimesSuffix:'2217 次收款',
    deleteSplitBtn:'2218 删除',
    splitableAmountLabel:'2219 可拆分金额：',
    addSplitBtn:'2220 新增',
    totalCollectionLabel:'2221 合计收款：',
    confirmPaymentBtn:'2222 确认收款',
    correctAmountError:'2223 请填写正确的金额',
    fillAmountFirstError:'2224 请先填写金额',
    validAmountError:'2225 请填写大于 0 的有效金额',
    chooseAssistantError:'2226 请选择营业员',
    chooseMemberError:'2227 请选择要充值的会员',
    chooseTemplateError:'2228 请选择一种充值模板',
    choosePaymentError:'2229 请至少选择一种支付方式',
    checkAmountError:'2230 请检查金额是否正确',
    cancelInvalidPaymentError:'2231 请取消勾选金额小于等于 0 元的收款方式',
    changeToolCash:'2232 现金',
    orderDetailTitle:'2233 详情',
    orderDetailGoodsInfoTitle:'2234 货品信息',
    orderDetailTotalItemsLabel:'2235 总件数：',
    orderDetailUnitPieceLabel:'2236 件',
    orderDetailOrderInfoTitle:'2237 单据信息',
    orderDetailTotalAmountLabel:'2238 本单金额：',
    orderDetailRetailAmountLabel:'2239 零售金额：',
    orderDetailReceivedAmountLabel:'2240 已收金额：',
    orderDetailActivityAmountLabel:'2241 活动金额：',
    orderDetailChangeAmountLabel:'2242 变动金额：',
    orderDetailSaleStatusLabel:'2243 销售状态：',
    orderDetailStatusCanceled:'2244 已取消',
    orderDetailStatusPendingPayment:'2245 待支付',
    orderDetailStatusPaying:'2246 支付中',
    orderDetailStatusPaid:'2247 已支付',
    orderDetailStatusPendingApproval:'2248 待审批',
    orderDetailStatusInvalid:'2249 已作废',
    orderDetailStoreNameLabel:'2250 店铺名称：',
    orderDetailGiftInfoLabel:'2251 赠品信息：',
    orderDetailSourceLabel:'2252 单据来源：',
    orderDetailSourceMobile:'2253 手机端',
    orderDetailSourceClient:'2254 客户端',
    orderDetailOrderTypeLabel:'2255 订单性质：',
    orderDetailSaleNoLabel:'2256 销售单号：',
    orderDetailOriginalSaleNoLabel:'2257 原销售单号：',
    orderDetailOuterNoLabel:'2258 外部单号：',
    orderDetailPerformanceMethodLabel:'2259 业绩方式：',
    orderDetailPerformancePersonal:'2260 个人业绩',
    orderDetailPerformanceTeam:'2261 班组业绩',
    orderDetailPerformanceDistribution:'2262 分销',
    orderDetailSalesmanLabel:'2263 营业员：',
    // orderDetailCreateTimeLabel:'2264 创建时间：',
    orderDetailTeamMembersLabel:'2265 班组人员：',
    orderDetailCreateTerminalLabel:'2266 创建订单收银台：',
    orderDetailEndTerminalLabel:'2267 结束订单收银台：',
    orderDetailPromotionInfoTitle:'2268 促销信息',
    orderDetailPromotionNameLabel:'2269 促销名称',
    orderDetailPromotionTypeLabel:'2270 促销类型',
    orderDetailPromotionNoLabel:'2271 促销编号',
    orderDetailPromotionDiscountAmountLabel:'2272 减扣金额',
    orderDetailPromotionDetailLabel:'2273 促销单详情',
    orderDetailViewDetailBtn:'2274 查看详情',
    orderDetailPaymentInfoTitle:'2275 收款信息',
    orderDetailPaymentMethodLabel:'2276 收款方式',
    orderDetailPaymentAmountLabel:'2277 收款金额',
    orderDetailPaymentStatusLabel:'2278 支付状态',
    orderDetailPaymentStatusCreated:'2279 已创建',
    orderDetailPaymentStatusPaid:'2280 已支付',
    orderDetailPaymentStatusCanceled:'2281 已取消',
    orderDetailPaymentStatusPaying:'2282 支付中',
    orderDetailCreateTimeLabel:'2283 创建时间',
    orderDetailUpdateTimeLabel:'2284 更新时间',
    orderDetailPaymentVoucherNoLabel:'2285 支付凭证号',
    orderDetailPaymentSerialNoLabel:'2286 流水号',
    orderDetailCouponNameLabel:'2287 优惠券名称',
    orderDetailCouponTypeLabel:'2288 优惠券类型',
    orderDetailCouponSourceLabel:'2289 优惠券来源',
    orderDetailCouponAmountLabel:'2290 优惠券金额',
    orderDetailTableOperationLabel:'2291 操作',
    scanPayTitle:'2292 扫码收款',
    scanPayWaitReceipt:'2293 等待到账',
    scanPaySuccessReceipt:'2294 到账成功',
    scanPayCancelled:'2295 已取消',
    scanPayPaymentItem:'2296 第',
    scanPayPaymentItem2:'2297 笔收款：¥',
    scanPayScanTip:'2298 请扫描顾客的付款码',
    scanPayConfirmBtn:'2299 确 认',
    scanPayPayFailed:'2300 第',
    scanPayPayFailed2:'2301 笔支付失败，请关闭或继续支付',
    scanPayCancelPayBtn:'2302 取消支付',
    scanPayWaitPayResult:'2303 第',
    scanPayWaitPayResult2:'2304 笔 提交成功，请等待金额到账',
    scanPayPayAttentionTip:'2305 请注意提醒顾客输入支付密码，否则可能支付失败！！！请留意支付结果。',
    scanPayCloseTip:'2306 关闭后可在会员充值记录中查看和再次发起支付',
    scanPayTipTitle:'2307 提示',
    scanPayPayingWaitMsg:'2308 当前订单正在支付中，请继续等待支付',
    vipTitle:'2309 会员',
    vipCreateBtn:'2310 创建会员',
    vipViewRechargeRecordBtn:'2311 查看本店会员充值记录',
    vipIntegralExchangeBtn:'2312 积分兑换',
    vipViewQrcodeBtn:'2313 查看店铺会员二维码',
    vipSearchPlaceholder:'2314 请输入 {title}',
    vipSearchPhoneLabel:'2315 手机号',
    vipSearchVipNameLabel:'2316 会员名称',
    vipSearchCardNumberLabel:'2317 卡号',
    vipSearchBtn:'2318 搜 索',
    vipSearchQuickLabel:'2319 快捷搜索：',
    vipSearchBirthdayThisMonthLabel:'2320 本月过生日的会员',
    vipInfoAvailableBalanceLabel:'2321 可用余额',
    vipInfoOccupiedBalanceLabel:'2322 占用余额',
    vipInfoIntegralLabel:'2323 积分',
    vipRechargeBtn:'2324 余额充值',
    vipFormMemberInfoTitle:'2325 会员信息',
    vipFormNicknameLabel:'2326 会员昵称:',
    vipFormRealNameLabel:'2327 真实姓名:',
    vipFormPhoneLabel:'2328 手机号:',
    vipFormGenderLabel:'2329 性别:',
    vipFormBoundStoreLabel:'2330 绑定店铺:',
    vipFormGuideLabel:'2331 发卡导购:',
    vipFormBirthdayLabel:'2332 生日:',
    vipFormIdCardLabel:'2333 身份证号:',
    vipFormIndustryLabel:'2334 从事行业:',
    vipFormCoatSizeLabel:'2335 上衣尺码:',
    vipFormTrousersSizeLabel:'2336 裤子尺码:',
    vipFormShoeSizeLabel:'2337 鞋子尺码:',
    vipFormCardNoLabel:'2338 会员卡号:',
    vipFormAveragePriceLabel:'2339 件单价:',
    vipFormAverageConsumptionLabel:'2340 平均消费:',
    vipSaveMemberBtn:'2341 保存会员信息',
    vipNoDataText:'2342 请选择会员',
    vipRecordConsumptionLabel:'2343 消费记录',
    vipRecordBalanceLabel:'2344 余额明细',
    vipRecordIntegralLabel:'2345 积分明细',
    vipRecordIntegralExchangeLabel:'2346 积分兑换记录',
    vipFilterTypeLabel:'2347 类型',
    vipFilterBillNoLabel:'2348 单号',
    vipFilterGoodsNoLabel:'2349 货号',
    vipFilterMultiGoodsNoLabel:'2350 多个货号用空格隔开',
    vipFilterExchangeTimeLabel:'2351 兑换时间',
    vipFilterTimeRangeLabel:'2352 时间范围',
    vipFilterStartDateLabel:'2353 开始日期',
    vipFilterEndDateLabel:'2354 结束日期',
    vipFilterResetBtn:'2355 重置',
    vipFilterConfirmBtn:'2356 确定',
    vipQrcodeTitle:'2357 查看店铺会员二维码',
    vipQrcodeDownloadBtn:'2358 下载图片',
    vipDialogTipTitle:'2359 提示',
    vipDialogLimitTipMsg:'2360 抱歉，该会员资格暂时受到限制，无法使用，我们建议您联系 IT 了解具体情况并解决问题。',
    vipDialogConfirmBtn:'2361 确 定',
    vipGridBillNoLabel:'2362 单号',
    vipGridTimeLabel:'2363 时间',
    vipGridQuantityLabel:'2364 件数',
    vipGridAmountLabel:'2365 金额',
    vipGridBeforeTransactionLabel:'2366 交易前',
    vipGridCurrentLabel:'2367 本次',
    vipGridAfterTransactionLabel:'2368 交易后',
    vipGridGoodsNameLabel:'2369 货品名称',
    vipPhoneLabel:'2370 手 机 号：',
    vipDialogNot:'2371 未知',
    vipDialogChoose:'2372 请先选择会员',
    vipDialogSave:'2373 信息保存成功',
    vipDialogNotMag:'2374 当前货品暂无图片预览',
    vipDialogNotNo:'2375 暂无法查看其他店铺订单',
    vipDialogBoy:'2376 男',
    vipDialogGirl:'2377 女',
    vipRechargeDialogTitle:'2378 会员充值记录',
    vipRechargeNewVipLabel:'2379 新增会员 (人)',
    vipRechargeRechargeTimesLabel:'2380 充值次数 (笔)',
    vipRechargeRechargeAmountLabel:'2381 充值金额 (元)',
    vipRechargeTimeRangeLabel:'2382 时间范围',
    vipRechargeStartDateLabel:'2383 开始日期',
    vipRechargeEndDateLabel:'2384 结束日期',
    vipRechargeVipNameLabel:'2385 会员名称',
    vipRechargePhoneLabel:'2386 手机号',
    vipRechargePleaseEnterText:'2387 请输入',
    vipRechargeStatusLabel:'2388 状态',
    vipRechargeResetBtn:'2389 重置',
    vipRechargeConfirmBtn:'2390 确定',
    vipRechargeMemberNameLabel:'2391 会员名称',
    vipRechargeOrderNoLabel:'2392 单号',
    vipRechargeAmountLabel:'2393 金额',
    vipRechargeBeforeRechargeLabel:'2394 充值前',
    vipRechargeAfterRechargeLabel:'2395 充值后',
    vipRechargeUnpaidAmountLabel:'2396 待支付金额',
    vipRechargePaidAmountLabel:'2397 已支付金额',
    vipRechargePaymentMethodLabel:'2398 支付方式',
    vipRechargeTimeLabel:'2399 时间',
    vipRechargeStateLabel:'2400 状态',
    vipRechargeUnpaidLabel:'2401 未支付',
    vipRechargePartialPaymentLabel:'2402 部分支付',
    vipRechargePaidLabel:'2403 已支付',
    vipRechargeCancelledLabel:'2404 已取消',
    vipRechargeOperationLabel:'2405 操作',
    vipRechargeContinuePaymentBtn:'2406 继续支付',
    vipRechargeCancelPaymentBtn:'2407 取消支付',
    vipRechargeConfirmCancelMsg:'2408 确认取消这笔充值记录？',
    vipRechargePromptTitle:'2409 提示',
    vipRechargeAmountChangedMsg:'2410 当前单据金额发生变化',
    vipRechargeSuccessLabel:'2411 成功',
    vipRechargeErrorLabel:'2412 错误',
    vipRechargeCloseBtn:'2413 关闭',
    membershipStatus:'3545 会员状态',
    normal:'3546 正常',
    blacklist:'3547 拉黑',
    abnormal:'3548 异常',
    requiredPoints:'3549 所需积分',
    exchangeQuantity:'3550 兑换数量',
    totalConsumptionPoints:'3551 消耗总积分',
    exchangeStore:'3552 兑换店铺',
    pageSummarizes:'3553 本页汇总',
  },
  //收银台
  deptCollectMoney:{
    indexLoadingText:'2414 请稍后，全力加载中...',
    indexNoDataText:'2415 当前页面暂无货品数据',
    verifiedTicket:'2416 已核销券',
    ticketCount:'2417 张',
    viewTicket:'2418 点击查看',
    promotionActivity:'2419 促销活动',
    activityType:'2420 活动类型',
    viewGift:'2421 查看赠品',
    chooseGift:'2422 选择赠品',
    viewAddPurchase:'2423 查看加购',
    chooseAddPurchase:'2424 选择加购',
    activityName:'2425 活动名称',
    viewGoods:'2426 查看货品',
    clearAction:'2427 清空',
    tabSell:'2428 售',
    tabExchange:'2429 换',
    tabGift:'2430 礼',
    scanPlaceholder:'2431 扫码添加 (按 alt + 1) 快速聚焦',
    scanTip:'2432 扫码时请将输入法切换成英文',
    goodsNoPlaceholder:'2433 手动输货号 / 简码',
    searchText:'2434 搜索',
    spuGoodsNo:'2435 货号',
    spuGoodsName:'2436 货品名称',
    spuClose:'2437 关闭',
    goodsColor:'2438 颜色',
    goodsSize:'2439 尺码',
    salesQuery:'2440 销售查询',
    goodsQuery:'2441 货品查询',
    defectiveSale:'2442 次品销售',
    vipFunction:'2443 会员功能',
    hangOrder:'2444 挂单取单',
    customOrder:'2445 客订记录',
    priceAdjust:'2446 调价通知',
    stockCard:'2447 库存账卡',
    ticketVerify:'2448 券码核销',
    timeTarget:'2449 时段目标',
    exchangeTitle:'2450 正在进行换货',
    exchangeDesc:'2451 跨店来退只允许换货，“换” 的货品按本店最新的货品金额计算。打一件 “换” 价值 100，下一件打 “售” 如果价值 80，则 “售” 视为价值 100；如果 “售” 的价值大于等于 100 则不受影响。',
    exchangeTotalPrice:'2452 换货总金额：',
    exchangeTotalNum:'2453 总件数：',
    personalPerformance:'2454 个人业绩',
    chooseShopGuide:'2455 请选择营业员',
    chooseTeam:'2456 选择班组人员',
    selectedTeam:'2457 已选择班组人员：',
    publicOrderClosed:'2458 公单未开启',
    publicOrderOpened:'2459 公单已开启',
    viewPublicOrderMembers:'2460 查看公单参与人员',
    vipName:'2461 会员名称',
    vipPhone:'2462 手机号',
    vipBalance:'2463 余额',
    vipIntegral:'2464 积分',
    vipReselect:'2465 重选',
    vipScanCode:'2466 请扫描会员码',
    vipInputPhone:'2467 请输入会员手机号',
    vipScanOrPhone:'2468 请输手机号或扫描会员码',
    vipTip:'2469 可在微信公众号打开[会员中心] 出示会员码',
    withTaxPrice: '零售总额',
    priceSalesCount:'数量',
    taxPrice: '税金',
    priceReceivable:'应收金额（含税）',
    priceTagTotal:'吊牌总价',
    priceTagDiscount:'2473 吊牌价抵扣',
    priceCouponDiscount:'2474 优惠券已抵',
    paySettle:'2475 买单',
    payQuick:'2476 快捷买单',
    dialogTip:'2477 提示',
    dialogVipRestrict:'2478 抱歉，该会员资格暂时受到限制，无法使用，我们建议您联系 IT 了解具体情况并解决问题。',
    performanceIndividual:'2479 个人业绩',
    dialogConfirm:'2480 确 定',
    inputGoodsNoOrShortCode:'2481 请输入货号或简码查询',
    noGoodsNoInfo:'2482 未查询到货号信息，请重新输入货号',
    chooseGoodsNo:'2483 请选择货号',
    salesRecordWindowName:'2484 销售记录',
    timeQuantumWindowName:'2485 时段业绩',
    performanceCalendarWindowName:'2486 业绩日历',
    customerOrderWindowName:'2487 客订记录',
    priceAdjustmentNoticeWindowName:'2488 调价通知',
    timeTargetFollowWindowName:'2489 时段目标跟进',
    cannotAddDefectiveGoods:'2490 当前货品列表不能添加次品，请清空后再添加',
    hangOrderWithCouponTip:'2491 本单使用了核销券，如果长时间挂单会自动将挂单记录清除，需要及时取单，否则清除后核销券将无法通过收银系统操作撤销或继续打单。确定要挂单？',
    confirmHangOrder:'2492 确定要挂单？',
    hangOrderConfirmTitle:'2493 挂单确认',
    operationSuccess:'2494 操作成功',
    cannotModifyShopGuide:'2495 开启公单后不允许修改营业员',
    onlyAddDefectiveGoods:'2496 当前为次品销售，只能添加次品',
    scanTagOrInputBarcode:'2497 请扫吊牌或输入条码',
    noGoodsInfo:'2498 没有查询到货品信息',
    cannotModifyDefectiveGiftGoods:'2499 次品、赠品、加购货品不允许修改数量、价格和颜色尺码',
    inputValidQuantity:'2500 请输入有效数量',
    confirmCancelPriceChange:'2501 确认要取消改价',
    tipText:'2502 提示',
    inputAmountGreaterThanZero:'2503 请输入大于 0 的金额',
    inputValidAmount:'2504 请输入有效金额',
    promotionCannotChangePrice:'2505 当前货品参与促销，左下角取消促销后再改价',
    cannotModifyDefectiveGoods:'2506 次品、赠品、加购货品不允许修改数量、价格和颜色尺码',
    confirmDeleteRecord:'2507 是否删除该条记录',
    confirmCancelVerification:'2508 确认撤销核销？',
    cancelVerificationTip:'2509 撤销提示',
    clearAfterCancelTicket:'2510 当前有已核销券，请先撤销核销再清空',
    confirmClearGoodsList:'2511 是否清空货品列表',
    operateSuccessText:'2512 操作成功',
    promotionConflictWithTicket:'2513 该促销与已核销券互斥不可选择',
    selectActivityFirst:'2514 请先选择该活动',
    activityMutualExclusion:'2515 当前活动与已选择的活动互斥不能选择',
    addGoodsFirst:'2516 请先添加商品',
    defectiveCannotChangePrice:'2517 当前为次品销售不允许改价',
    exchangeNoRefund:'2518 换货不支持退款，请推荐更换等价或更高价值的货品！',
    addExchangeGoodsFirst:'2519 请先添加要换的货品！',
    publicOrderClosedTip:'2520 当前店铺公单已关闭，请重新设置',
    selectShopGuideFirst:'2521 请选择营业员',
    priceChangeOverLimit:'2522 货品金额超出可改范围，请提交改价申请。改价需申请货品货号：',
    priceChangeLimitTitle:'2523 改价金额超出限制',
    settlementCompleted:'2524 结算完成！',
    paySuccessText:'2525 买单成功',
    clearPinkerTicketFirst:'2526 当前有已核销的品氪优惠券，请撤销后再重选会员',
    defectiveCannotVerifyTicket:'2527 当前为次品销售不可以操作券码核销，请清空后操作。',
    orderPriceModifyTitle:'2528 整单改价',
    orderPriceTotalAmount:'2529 本单总金额',
    orderPriceModifyAmount:'2530 改价金额',
    orderPriceEnterModifyAmount:'2531 请输入改价金额',
    orderPriceCancel:'2532 取 消',
    orderPriceConfirm:'2533 确 定',
    orderPriceEnterPriceMsg:'2534 请填写改价金额',
    chooseSpecificationTitle:'2535 选择规格',
    loadingText:'2536 请稍后，全力加载中...',
    // noImageText:'2537 暂无图片',
    goodsInfoArticleNo:'2538 货号：',
    goodsInfoBarCode:'2539 条码：',
    goodsInfoStock:'2540 库存：',
    goodsInfoPiece:'2541 件',
    operationCancel:'2542 取 消',
    operationConfirm:'2543 确 定',
    messagePleaseChooseSize:'2544 请先选择尺码',
    messagePleaseChooseColor:'2545 请先选择颜色',
    messageMinNumber:'2546 最小数量为 1，不能再减了',
    messageStockInsufficient:'2547 当前货品库存不足',
    messageEnterValidNumber:'2548 请填写大于或等于 1 的整数',
    messagePleaseSelectColor:'2549 请选择颜色',
    messagePleaseSelectSize:'2550 请选择尺码',
    complimentariesTitle:'2551 赠品信息',
    complimentariesSearchPlaceholder:'2552 请输入货号、条码或者扫吊牌条码查询',
    complimentariesQueryBtn:'2553 查询',
    complimentariesNoImage:'2554 暂无图片',
    complimentariesGoodsNoLabel:'2555 货号：',
    complimentariesBarCodeLabel:'2556 条码：',
    complimentariesCancelBtn:'2557 取 消',
    complimentariesConfirmBtn:'2558 确 定',
    complimentariesErrorReachLimit:'2559 当前选中的赠品已达到活动设置的上限',
    complimentariesErrorCannotReduce:'2560 当前数量为 0，不能再减少了',
    complimentariesErrorMaxGift:'2561 当前活动最多只能选择 {count} 件赠品',
    changePriceTitle:'2562 改价申请',
    changePriceApplyInfo:'2563 申请单信息',
    changePriceSubmitUser:'2564 提交人',
    changePricePleaseSelect:'2565 请选择',
    changePriceSubmitTime:'2566 提交时间',
    changePriceShopName:'2567 店铺名称',
    changePriceOriginalPrice:'2568 原价',
    changePriceAlteredAmount:'2569 改后金额',
    changePriceChangeAmount:'2570 变动金额',
    changePriceRemarks:'2571 备注',
    changePricePleaseEnterRemarks:'2572 请输入备注',
    changePricePriceChangedGoods:'2573 改价货品',
    changePriceType:'2574 类型',
    changePriceNoImage:'2575 暂无图片',
    changePriceGoodsInfo:'2576 货品信息',
    changePriceItemNo:'2577 货号：',
    changePriceBarcode:'2578 条码：',
    changePriceColorSize:'2579 颜色 / 尺码',
    changePriceAvailableStock:'2580 可用库存：',
    changePriceTagPrice:'2581 吊牌价',
    changePriceDiscount:'2582 折扣',
    changePriceQuantity:'2583 数量',
    changePriceBeforeAlterPrice:'2584 改前单价',
    changePriceAfterAlterPrice:'2585 改后单价',
    changePriceBeforeTotalPrice:'2586 改前总价',
    changePriceAfterTotalPrice:'2587 改后总价',
    changePriceCancel:'2588 取 消',
    changePriceConfirm:'2589 确 定',
    changePricePleaseSelectApplicant:'2590 请选择申请人',
    changePricePleaseFillApprovalRemarks:'2591 请填写审批备注',
    changePricePriceChangeApplicationSubmitted:'2592 改价申请已提交',
    changePriceIncrease:'2593 增加',
    changePriceDecrease:'2594 减少',
    changePriceConfirmDeleteCoupon:'2595 是否删除该优惠券',
    changePricePrompt:'2596 提示',
    orderRemarkTitle:'2597 整单备注',
    orderRemarkPlaceholder:'2598 请输入备注',
    commonCancel:'2599 取 消',
    commonConfirm:'2600 确 定',
    goodsQuery_title:'货品查询',
    goodsQuery_scanBarcodeLabel:'2602 扫吊牌条码查询',
    goodsQuery_scanPlaceholder:'2603 请扫描',
    goodsQuery_goodsNoOrCodeLabel:'2604 货号 / 简码',
    goodsQuery_inputPlaceholder:'2605 请输入',
    goodsQuery_styleCategoryLabel:'2606 款式分类',
    goodsQuery_yearLabel:'2607 年份',
    goodsQuery_selectPlaceholder:'2608 请选择',
    goodsQuery_quarterLabel:'2609 季节',
    goodsQuery_spring:'2610 春季',
    goodsQuery_summer:'2611 夏季',
    goodsQuery_autumn:'2612 秋季',
    goodsQuery_winter:'2613 冬季',
    goodsQuery_allSeason:'2614 通季',
    goodsQuery_styleClassificationLabel:'2615 风格分类',
    goodsQuery_sizeLabel:'2616 尺码',
    goodsQuery_colorLabel:'2617 颜色',
    goodsQuery_colorTip:'2618 可按吊牌颜色精准查询，也可按颜色关键字模糊查询，如输入黑，可查询带 “黑” 的颜色',
    goodsQuery_searchBtn:'2619 查询 (回车键)',
    goodsQuery_resetBtn:'2620 重置',
    goodsQuery_goodsListLabel:'2621 货品列表',
    goodsQuery_showStockLabel:'2622 显示库存：',
    goodsQuery_stockLabel:'2623 库存',
    goodsQuery_occupyStockLabel:'2624 占用库存',
    goodsQuery_usableStockLabel:'2625 可用库存',
    goodsQuery_onlyAdjustedLabel:'2626 仅看有调价',
    goodsQuery_onlyHasStockLabel:'2627 仅看有 [库存]',
    goodsQuery_onlyNegativeStockLabel:'2628 仅看负 [库存]',
    goodsQuery_filterResetBtn:'2629 重置',
    goodsQuery_loadingText:'2630 请稍后，全力加载中...',
    goodsQuery_noStockDataText:'2631 暂无库存数据',
    goodsQuery_noImageText:'2632 暂无图片',
    goodsQuery_adjustPriceLabel:'调价',
    goodsQuery_goodsNoColonLabel:'2634 货号：',
    goodsQuery_colorColonLabel:'2635 颜色：',
    goodsQuery_tagPriceLabel:'2636 吊牌价：¥',
    goodsQuery_retailPriceLabel:'2637 零售价：¥',
    goodsQuery_currentSellingPriceLabel:'2638 当前销售价：',
    goodsQuery_adjustEffectiveDateLabel:'2639 调价生效日期：',
    goodsQuery_correspondingBarcodeLabel:'2640 对应的条码：',
    goodsQuery_totalLabel:'2641 合计',
    goodsQuery_otherShopsLabel:'2642 其他店铺',
    goodsQuery_stockAccountCardLabel:'2643 库存账卡',
    goodsQuery_addToCashierLabel:'2644 加入收银台',
    goodsQuery_otherShopsStockTitle:'其他店铺【可用库存】',
    goodsQuery_enterShopNamePlaceholder:'2646 请输入店铺名称',
    goodsQuery_shopSearchBtn:'2647 搜 索',
    goodsQuery_showOnlyHasStockLabel:'2648 只显示有库存',
    goodsQuery_barcodeColonLabel:'2649 条码：',
    goodsQuery_noDataText:'2650 暂无数据',
    goodsQuery_shopNameColonLabel:'2651 店铺名称：',
    goodsQuery_distanceColonLabel:'2652 距离本店：',
    goodsQuery_contactPhoneColonLabel:'2653 联系电话：',
    goodsQuery_availableStockLabel:'2654 可用库存',
    goodsQuery_selectSizeTip:'2655 请选择尺码',
    goodsQuery_all:'2656 合计',
    noImage:'2657 暂无图片',
    gift:'2658 赠品',
    addBuy:'2659 加购',
    promotion:'2660 促销',
    goodsNo:'2661 货号：',
    barcode:'2662 条码：',
    quantity:'2663 件数：',
    salesInquiryTitle:'2664 销售查询',
    salesInquiryTabsTodayFlow:'2665 当天流水',
    salesInquiryTabsYesterdayFlow:'2666 昨天流水',
    salesInquiryTabsTodayPerformance:'2667 当天业绩',
    salesInquiryTabsYesterdayPerformance:'2668 昨天业绩',
    salesInquiryTabsHistorySales:'2669 历史销售',
    salesInquiryTableSalesOrderNo:'2670 销售单号',
    salesInquiryTableName:'2671 姓名',
    salesInquiryTableQuantity:'2672 件数',
    salesInquiryTableAmount:'2673 金额',
    salesInquiryTableSalesTime:'2674 销售时间',
    salesInquiryTableOrderCount:'2675 单数',
    salesInquiryTableTotalAmount:'2676 金额',
    salesInquiryTablePublicOrder:'2677 公单',
    salesInquiryTablePerformanceTotal:'2678 业绩合计',
    salesInquiryTableDate:'2679 日期',
    salesInquiryTotalCash:'2680 现金',
    salesInquiryTotalLkl:'2681 拉卡拉',
    salesInquiryTotalScan:'2682 扫码',
    salesInquiryTotalMember:'2683 会员',
    salesInquiryTotalTotalAmount:'2684 总金额',
    salesInquirySummaryTotal:'2685 合计',
    salesInquiryMessageError:'2686 错误',
    salesUserListTitle:'2741 选择营业员',
    salesUserListSearchPlaceholder:'2742 搜索营业员',
    salesUserListCurrentSalesperson:'2743 当前营业员：',
    salesUserListNoData:'2744 暂无营业员',
    salesUserListCancel:'2745 取 消',
    salesUserListConfirm:'2746 确 定',
    salesUserListErrorVipSingle:'2747 请选择一个营业员',
    salesUserListErrorMultiRequired:'2748 请选择两个或两个以上营业员，只有一个营业员请选择个人业绩',
    salesUserListCode:'2749 编号：',
    saleBadGoodsTitle:'2750 次品销售',
    saleBadGoodsWarning:'2751 温馨提示：次品销售后，不退不换。',
    saleBadGoodsStateApproved:'2752 审批通过',
    saleBadGoodsStatePending:'2753 待审批',
    saleBadGoodsStateCancelled:'2754 已作废',
    saleBadGoodsLabelGoodsName:'2755 货品名称',
    saleBadGoodsPlaceholderGoodsName:'2756 请输入货品名称',
    saleBadGoodsLabelBarcodeOrGoodsNo:'2757 条码 / 货号',
    saleBadGoodsPlaceholderBarcodeOrGoodsNo:'2758 请输入条码 / 货号',
    saleBadGoodsButtonSearch:'2759 查 询',
    saleBadGoodsButtonApplyQrcode:'2760 次品申请二维码',
    saleBadGoodsNoImage:'2761 暂无图片',
    saleBadGoodsLabelSaleableQuantity:'2762 可售数量：',
    saleBadGoodsLabelApplyQuantity:'2763 申请数量：',
    saleBadGoodsLabelSellingPrice:'2764 售价：',
    saleBadGoodsLabelTagPrice:'2765 吊牌价：',
    saleBadGoodsButtonAddToCashier:'2766 加入收银台',
    saleBadGoodsButtonCancel:'2767 作废',
    saleBadGoodsStatusCancelled:'2768 已作废',
    saleBadGoodsStatusApproving:'2769 正在审批中',
    saleBadGoodsLabelReviewer:'2770 审批人：',
    saleBadGoodsEmptyStateTitle:'2771 APP 扫码即可快速跳转到次品申请页面',
    saleBadGoodsEmptyStateDesc:'2772 快扫码试试吧！',
    saleBadGoodsQrcodeDialogTitle:'2773 次品申请二维码',
    saleBadGoodsMessageMaxSaleableQuantity:'2774 当前次品最大可售数量为：{count} 件',
    saleBadGoodsConfirmCancel:'2775 确定将该次品标记为作废，作废后将会删除该次品',
    saleBadGoodsConfirmTitle:'2776 提示',
    stockAccountCardTitle:'2777 库存账卡',
    stockAccountCardFormGoodsNo:'2778 货号',
    stockAccountCardFormSn:'2779 单据编号',
    stockAccountCardFormInvoicesType:'2780 单据类型',
    stockAccountCardFormDateRange:'2781 日期范围',
    stockAccountCardPlaceholderInput:'2782 请输入',
    stockAccountCardPlaceholderSelect:'2783 请选择',
    stockAccountCardPlaceholderStartDate:'2784 开始日期',
    stockAccountCardPlaceholderEndDate:'2785 结束日期',
    stockAccountCardButtonQuery:'2786 查询',
    stockAccountCardTableInvoicesDate:'2787 变动日期',
    stockAccountCardTableInvoicesType:'2788 单据类型',
    stockAccountCardTableSn:'2789 单据编号',
    stockAccountCardTableGoodsNo:'2790 货号',
    stockAccountCardTableGoodsName:'2791 货品名称',
    stockAccountCardTableColor:'2792 颜色',
    stockAccountCardTableOutUnitCode:'2793 出库单位编号',
    stockAccountCardTableOutUnitName:'2794 出库单位名称',
    stockAccountCardTableInUnitCode:'2795 入库单位编号',
    stockAccountCardTableInUnitName:'2796 入库单位名称',
    stockAccountCardInvoicesType1:'2797 零售核销单',
    stockAccountCardInvoicesType2:'2798 店铺调拨单',
    stockAccountCardInvoicesType3:'2799 店铺配货单',
    stockAccountCardInvoicesType4:'2800 店铺退仓单',
    stockAccountCardInvoicesType5:'2801 盘点过账',
    stockAccountCardInvoicesType6:'2802 库存调整单',
    stockAccountCardInvoicesType7:'2803 积分兑换',
    stockAccountCardInvoicesType8:'2804 店铺客订单',
    stockAccountCardMessageGoodsNoRequired:'2805 货号不能为空',
    stockAccountCardMessageDateRequired:'2806 日期不能为空',
    stockAccountCardTableSum:'2807 合计',
    stockAccountCardTableStart:'2808 期初',
    stockAccountCardTableEnd:'2809 期末',
    stockAccountCardTo:'2810 至',
    tradeInDialogTitle:'2811 加购货品信息',
    tradeInDialogSearchPlaceholder:'2812 请输入货号、条码或者扫吊牌条码查询',
    tradeInDialogQueryBtn:'2813 查询',
    tradeInDialogNoImage:'2814 暂无图片',
    tradeInDialogGoodsNo:'2815 货号：',
    tradeInDialogBarCode:'2816 条码：',
    tradeInDialogAddPrice:'2817 加购价：',
    tradeInDialogOriginalPrice:'2818 原价：',
    tradeInDialogCancelBtn:'2819 取 消',
    tradeInDialogConfirmBtn:'2820 确 定',
    tradeInDialogErrorMaxReached:'2821 当前选中的加购货品已达到活动设置的上限',
    tradeInDialogErrorCannotReduce:'2822 当前数量为 0，不能再减少了',
    tradeInDialogErrorExceedMax:'2823 当前活动最多只能选择 {count} 件加购货品',
    publicUserSetParticipant:'2824 设置参与公单人员',
    publicUserParticipantList:'2825 参与公单的人员',
    publicUserPerformanceLogic:'2826 公单业绩计算逻辑：',
    publicUserPerformanceFormula:'2827 打单业绩 ÷ 参与公单人员的总份额 × 个人的份额',
    publicUserSelectParticipant:'2828 请选择参与人员',
    publicUserShopPublicShare:'2829 本店公单份额',
    publicUserShopManager:'2830 店长',
    publicUserShopAssistant:'2831 店助',
    publicUserShopGuide:'2832 导购',
    publicUserPartTime:'2833 临时工',
    publicUserCancel:'2834 取消',
    publicUserConfirm:'2835 确定',
    publicUserName:'2836 姓名',
    publicUserPosition:'2837 职位',
    publicUserMinParticipantError:'2838 参与公单的人员不能少于两个人',
    publicUserOpenSuccess:'2839 店铺公单已开启',
    checkTicketTitle:'2840 优惠券核销',
    checkTicketChannelDouyin:'2841 抖音核销',
    checkTicketChannelKuaishou:'2842 快手核销',
    checkTicketChannelWechat:'2843 微信卡券',
    checkTicketCurrentChannel:'2844 当前验券渠道为：',
    checkTicketScanTip:'2845 请扫描顾客的优惠券码',
    checkTicketSubmitBtn:'2846 确认提交券码',
    checkTicketChooseVerificationWay1:'2847 该券码有 {codeTicketList} 种核销方式，请选择 1 种进行核销。',
    checkTicketSource:'2849 来源：',
    checkTicketType:'2850 类型：',
    checkTicketValidityPeriod:'2851 有效期：',
    checkTicketUnusableReason:'2852 不可用原因：',
    checkTicketRescanBtn:'2853 重扫券码',
    checkTicketConfirmChooseWayBtn:'2854 确认选择该核销方式',
    checkTicketConfirmVerificationBtn:'2855 确认核销',
    checkTicketErrorMemberInconsistentWithPinker:'2856 会员不一致，请先撤销品氪优惠券',
    checkTicketErrorMemberInconsistent:'2857 会员不一致，请先取消选择会员',
    checkTicketErrorChooseOneWay:'2858 请选择 1 种进行核销',
    ticketGoodDialogTitle:'2859 优惠券核销选择货品（扫码请将输入法切换至英文）',
    ticketGoodSource:'2860 来源：',
    ticketGoodType:'2861 类型：',
    ticketGoodValidity:'2862 有效期：',
    ticketToDate:'2863 至',
    ticketGoodReScanCode:'2864 重扫券码',
    ticketGoodScanPlaceholder:'2865 扫描货品条码添加，手输时需按回车键',
    ticketGoodChooseGift:'2866 选择赠品 (至多 {giftNumLimit} 件)',
    ticketGoodDeductTagPrice:'2867 抵吊牌价 {tagTriceAmount} 元',
    noImageText:'2868 暂无图片',
    ticketGoodAvailableStock:'2869 可用库存：',
    ticketGoodTagPriceLabel:'2870 吊牌价：',
    ticketGoodCurrentRetailPriceLabel:'2871 当前零售价：',
    ticketGoodPiece:'2872 件',
    ticketGoodGroup:'2873 组',
    ticketGoodDelete:'2874 删除',
    ticketGoodNoGift:'2875 暂无赠品，请先添加赠品',
    ticketGoodAddMinus:'2876 加减',
    ticketGoodTip:'2877 提示',
    ticketGoodCombination:'2878 搭配',
    ticketGoodNoGoods:'2879 暂无货品，请先添加货品',
    ticketGoodGift:'2880 赠品',
    ticketGoodCouponDesc:'2881 优惠券说明',
    ticketGoodSatisfiedCombination:'2882 已满足组合搭配 (点击选择组合搭配)',
    ticketGoodNoSatisfiedCombination:'2883 暂未满足任何搭配',
    ticketGoodPriceCalculation:'2884 价格计算',
    ticketGoodGroupSubtotal:'2885 {index} 组小计：¥{goodsAmount}',
    ticketGoodNeedMakeUp:'2886 需补差价 ¥{differenceAmount}',
    ticketGoodTagPriceTotal:'2887 吊牌价合计（不含赠品）：¥{goodsTagPrice}',
    ticketGoodTotal:'2888 总计（不含赠品）：¥{goodsRetailPrice}',
    ticketGoodTotalReceivable:'2889 总应收：¥{realPrice}',
    ticketGoodClear:'2890 清 空',
    ticketGoodConfirmCheck:'2891 确定货品并核销',
    ticketGoodFinishChoose:'2892 完成选择',
    ticketGoodConfirmDeleteGoods:'2893 确认要删除货品？',
    ticketGoodConfirmClearGoods:'2894 确认要清空货品吗？',
    ticketGoodNoGoodsOrGift:'2895 暂无货品或赠品',
    ticketGoodPleaseScan:'2896 请扫吊牌或输入条码',
    ticketListVerifiedTickets:'2897 已核销券',
    ticketListNoImage:'2898 暂无图片',
    ticketListPiece:'2899 件',
    ticketListGift:'2900 赠品',
    ticketListTotal:'2901 共',
    ticketListItem:'2902 款',
    ticketListTagPrice:'2903 吊牌价',
    ticketListOriginalPrice:'2904 原价',
    ticketListTagDiscount:'2905 吊牌优惠',
    ticketListDiscount:'2906 优惠',
    ticketListReduce:'2907 减',
    ticketListNeedMakeUp:'2908 需补差',
    ticketListNoRefund:'2909 差额不退',
    ticketListChooseGift:'2910 选择赠品',
    ticketListReselectVerification:'2911 重选核销方式',
    ticketListReselectGoods:'2912 重选货品',
    ticketListCancelVerification:'2913 撤销核销',
    ticketListConfirmCancel:'2914 确定撤销核销？',
    ticketListCancelPrompt:'2915 撤销提示',
    ticketGiveTitle:'2916 选择赠品',
    ticketGivePlaceholder:'2917 扫描货品条码添加，手输时需按回车键',
    ticketGiveGiftLimit:'2918 至多 {giftNumLimit} 件赠品，已选 {giftNum} 件',
    ticketGiveEmptyTip:'2919 请扫码添加赠品',
    ticketGiveNoImage:'2920 暂无图片',
    ticketGiveTagPrice:'2921 吊牌价：',
    ticketGiveRetailPrice:'2922 当前零售价：',
    ticketGiveAvailableStock:'2923 可用库存：',
    ticketGiveClose:'2924 关 闭',
    ticketGiveConfirm:'2925 确 认',
    ticketGiveMaxGiftError:'2926 已达赠品上限，不能再添加了！',
    typeAddedGoods:'3389 添加的货品类型'
  },
  //app
  app:{
    publicTest:'3387 公测'
  },
  // 状态标签
  statusTag: {
    sended: '3520 已下发',
    orderpack: '3521 拣货中',
    orderpacked: '3522 拣货完成',
    packing: '3523 打包中',
    packed: '3524 打包完成',
    outed: '3525 已出货',
    checked: '3526 已签收',
    void: '3527 已作废',
    joined: '3528 已入库'
  }
}
